// Le catalogue des modules vit désormais dans lib/modulesCatalog (sorti d'ici le 2026-09-20 pour que
import { familleCompte } from './lib/modulesCatalog';
// les écrans du super admin puissent l'importer sans cycle). Ré-exporté : les imports existants tiennent.
import { ALL_MODULES, getModulesForClientType } from './lib/modulesCatalog';
import { useMoiCommerciaux, chargerMoiCommerciaux } from './components/Commerciaux/useMoiCommerciaux';
import { AccueilCommercial } from './components/Commerciaux/AccueilCommercial';
import type { ClientType } from './lib/modulesCatalog';
export type { ClientType } from './lib/modulesCatalog';
export { ALL_MODULES, getModulesForClientType } from './lib/modulesCatalog';

const ACTIONS_TRANSLATION = {
    'PRINT_INVOICE': 'Impression Facture',
    'MODULE_VISIT': 'Navigation Module',
    'PRINT_DOCUMENT': 'Impression Document',
    'DOWNLOAD_DOCUMENT': 'Téléchargement Document'
};

import React, { useState, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LoginPage } from './components/Auth/LoginPage';
import { DashboardHeader, DashboardStats, DashboardShortcut, DashboardSection, PILL } from './components/Dashboard/DashboardUi';
import { RestaurationDashboard } from './components/Dashboard/RestaurationDashboard';
import { AmbianceProvider, AmbianceAccent } from './components/Ambiance/AmbianceContext';
import { UndoProvider } from './components/ui/UndoBar';
import { ConfirmProvider, useConfirm } from './components/ui/ConfirmProvider';
import { OrganisationProvider, useOrganisation } from './components/Organisation/OrganisationContext';
import { SelecteurContexte } from './components/Organisation/SelecteurContexte';
import { OrganisationPage } from './components/Organisation/OrganisationPage';
import { EtablissementPage } from './components/Organisation/EtablissementPage';
import { ServicePage } from './components/Organisation/ServicePage';
import { MesModulesPage } from './components/Organisation/MesModulesPage';
const MonAbonnementPage = lazy(() => import('./components/Abonnements/MonAbonnementPage').then(m => ({ default: m.MonAbonnementPage })));
import { AdminOrganisationPage } from './components/Organisation/AdminOrganisationPage';
import { GroupesAdminPage } from './components/Organisation/GroupesAdminPage';
import { DemandesModulesPage } from './components/Organisation/DemandesModulesPage';
import { PolesGroupePage } from './components/Organisation/PolesGroupePage';
import { PolesGroupeAdminPage } from './components/Organisation/PolesGroupeAdminPage';
import { IntegrationListePage } from './components/Integration/IntegrationListePage';
import { IntegrationDossierPage } from './components/Integration/IntegrationDossierPage';
import { EquipeRoutes, AdminEquipeRoutes } from './components/Equipe/EquipeShell';
import { DemanderAccesPage } from './components/Equipe/DemanderAccesPage';
import { InvitationPublique } from './components/Equipe/InvitationPublique';
import { ReservationsPage } from './components/Reservations/ReservationsPage';
import { ReglagesServicesPage } from './components/Reservations/ReglagesServicesPage';
import { ServiceEditionPage } from './components/Reservations/ServiceEditionPage';
import { FormatsTablesPage } from './components/Reservations/FormatsTablesPage';
import { PlanDeSalleHote } from './components/Reservations/PlanDeSalleHote';
import { LegalMentions } from './components/legal/LegalMentions';
import { PrivacyPolicy } from './components/legal/PrivacyPolicy';
import { LegalLayout } from './components/legal/LegalLayout';
import { TermsOfUse } from './components/legal/TermsOfUse';
import { TermsGate } from './components/legal/TermsGate';
import { MotDePasseProvisoireBanner } from './components/Employee/MotDePasseProvisoireBanner';
import { AideGuidee } from './components/Guide/AideGuidee';
import { 
    LayoutDashboard,
    Users,
    Calendar,
    Briefcase,
    Zap,
    FileText, 
    Settings, 
    LogOut, 
    Plus, 
    CheckCircle, 
    XCircle,
    ChevronRight,
    ShieldCheck,
    Bot,
    Tag,
    Layers,
    ShieldAlert,
    Lock,
    Mail,
    Trash2,
    ToggleLeft,
    ToggleRight,
    Search,
    Filter,
    Download,
    MapPin,
    UserCheck,
    Trophy,
    Palette,
    Building2,
    Network,
    ClipboardCheck,
    UserCog,
    KeyRound,
    CreditCard,
    Phone,
    MessageSquare,
    Paperclip,
    FileSpreadsheet,
    Upload,
    AlertCircle,
    CheckCircle2,
    X,
    Sun,
    Moon,
    Save,
    FileJson,
    Clock,
    UtensilsCrossed,
    BookOpen,
    ChefHat,
    Utensils,
    Beef,
    UserPlus,
    Info,
    Package,
    CalendarClock,
    CalendarCheck,
    ClipboardList,
    Send,
    Gamepad2,
    ListChecks,
    Receipt,
    ChevronDown,
    NotebookText,
    Truck,
    HardHat,
    Repeat,
    Megaphone,
    QrCode,
    Star,
    FileSignature,
    ShoppingBag,
  Inbox,
} from 'lucide-react';
import { motion, AnimatePresence } from 'motion/react';
import { authApi, adminApi, moduleApi, supportApi, dashboardApi, planningApi, apiFetch, publicRdvProBookingApi } from './lib/api';
import { equipeApi } from './lib/equipeApi';
import { abonnementsApi } from './lib/abonnementsApi';
import { conseillereApi, conseillereAdminApi } from './lib/conseillereApi';
import { extractRowsFromPdfClient, extractEvenementielRowsFromPdfClient } from './lib/pdfExtractor';
import { resolveLogoUrl } from './lib/resolveLogoUrl';
import { resizeImageForUpload } from './lib/resizeImageForUpload';
import { isCarteShortPath } from './lib/carteUrls';
const EvenementielModule = lazy(() => import('./components/Evenementiel/EvenementielModule').then(m => ({ default: m.EvenementielModule })));
const EvenementielSettingsPage = lazy(() => import('./components/Evenementiel/module/EvenementielSettingsPage').then(m => ({ default: m.EvenementielSettingsPage })));
const EvenementielConvivesPage = lazy(() => import('./components/Evenementiel/convives/EvenementielConvivesPage').then(m => ({ default: m.EvenementielConvivesPage })));
const MenusConvivesListPage = lazy(() => import('./components/Evenementiel/convives/MenusConvivesListPage').then(m => ({ default: m.MenusConvivesListPage })));
import { SuiviPrivatisationModule } from './components/SuiviPrivatisation/SuiviPrivatisationModule';
import { SuiviPrivatisationLayout } from './components/SuiviPrivatisation/SuiviPrivatisationLayout';
import { DossierPipelinePage } from './components/SuiviPrivatisation/DossierPipelinePage';
import { DossiersHub } from './components/PrestationDossier/DossiersHub';
import { CommissionsPage } from './components/PrestationPlanning/CommissionsPage';
const CommerciauxPage = lazy(() => import('./components/Commerciaux/CommerciauxPage').then(m => ({ default: m.CommerciauxPage })));
const EquipeCommercialePage = lazy(() => import('./components/Commerciaux/EquipePage').then(m => ({ default: m.EquipePage })));
const PageProspects = lazy(() => import('./components/Prospects/PageProspects').then(m => ({ default: m.PageProspects })));
const ChallengesCommerciauxPage = lazy(() => import('./components/Commerciaux/ChallengesPage').then(m => ({ default: m.ChallengesPage })));
import { HorairesEquipePage } from './components/PrestationPlanning/HorairesEquipePage';
import { DossierPrestationPipelinePage } from './components/PrestationDossier/DossierPrestationPipelinePage';
import { MenuCatalogPage } from './components/Evenementiel/menu/MenuCatalogPage';
import { AllergenFamiliesPage } from './components/Evenementiel/menu/AllergenFamiliesPage';
import { ConvivesSuiviPage } from './components/Evenementiel/convives/ConvivesSuiviPage';
import ModeTerrainPage from './components/Evenementiel/convives/ModeTerrainPage';
import ModeTerrainListPage from './components/Evenementiel/convives/ModeTerrainListPage';
import OrigineViandesPage from './components/Cuisine/OrigineViandesPage';
import { QrCodesPage } from './components/Evenementiel/convives/QrCodesPage';
import { RdvProModule } from './components/RdvPro/RdvProModule';
import { RdvCancellationHistoryPage } from './components/RdvPro/RdvCancellationHistoryPage';
import { SendDocumentByEmailModal } from './components/RdvPro/SendDocumentByEmailModal';
import { PlanningModule } from './components/Planning/PlanningModule';
import { RoadmapPage } from './components/Planning/Roadmap/RoadmapPage';
import { FacturesModule } from './components/Factures/FacturesModule';
import { AchatsModule } from './components/Achats/AchatsModule';
const CRMModule = lazy(() => import('./components/CRM/CRMModule').then(m => ({ default: m.CRMModule })));
import { TodoModule } from './components/Todo/TodoModule';
import { FloatingTodoWidget } from './components/Todo/FloatingTodoWidget';
import { NotesModule } from './components/Notes/NotesModule';
const FournisseursModule = lazy(() => import('./components/Fournisseurs/FournisseursModule').then(m => ({ default: m.FournisseursModule })));
const CatalogueFournisseurPage = lazy(() => import('./components/CatalogueFournisseur/CatalogueFournisseurPage').then(m => ({ default: m.CatalogueFournisseurPage })));
const LivraisonPage = lazy(() => import('./components/FournisseurPortail/LivraisonPage').then(m => ({ default: m.LivraisonPage })));
const MesClientsPage = lazy(() => import('./components/FournisseurPortail/MesClientsPage').then(m => ({ default: m.MesClientsPage })));
const DemandesPage = lazy(() => import('./components/FournisseurPortail/DemandesPage').then(m => ({ default: m.DemandesPage })));
const ProfilPublicPage = lazy(() => import('./components/FournisseurPortail/ProfilPublicPage').then(m => ({ default: m.ProfilPublicPage })));
const AnnuairePage = lazy(() => import('./components/Fournisseurs/annuaire/AnnuairePage').then(m => ({ default: m.AnnuairePage })));
const ProfilFournisseurPage = lazy(() => import('./components/Fournisseurs/annuaire/ProfilFournisseurPage').then(m => ({ default: m.ProfilFournisseurPage })));
const MesDemandesPage = lazy(() => import('./components/Fournisseurs/annuaire/MesDemandesPage').then(m => ({ default: m.MesDemandesPage })));
const CommandesRecuesPage = lazy(() => import('./components/FournisseurPortail/CommandesRecuesPage').then(m => ({ default: m.CommandesRecuesPage })));
const SupplierDetailPage = lazy(() => import('./components/Fournisseurs/SupplierDetailPage').then(m => ({ default: m.SupplierDetailPage })));
const SupplierOrdersPage = lazy(() => import('./components/Fournisseurs/SupplierOrdersPage').then(m => ({ default: m.SupplierOrdersPage })));
const SupplierArticlesPage = lazy(() => import('./components/Fournisseurs/SupplierArticlesPage').then(m => ({ default: m.SupplierArticlesPage })));
const SupplierCategoryArticlesPage = lazy(() => import('./components/Fournisseurs/SupplierCategoryArticlesPage').then(m => ({ default: m.SupplierCategoryArticlesPage })));
const CommandesModule = lazy(() => import('./components/Fournisseurs/CommandesPage').then(m => ({ default: m.CommandesPage })));
const BonCommandePublicPage = lazy(() => import('./components/Public/BonCommandePublicPage').then(m => ({ default: m.BonCommandePublicPage })));
const ExtrasPartnersModule = lazy(() => import('./components/Extras/ExtrasPartnersModule').then(m => ({ default: m.ExtrasPartnersModule })));
const ExtrasPartnerDetailPage = lazy(() => import('./components/Extras/ExtrasPartnerDetailPage').then(m => ({ default: m.ExtrasPartnerDetailPage })));
const ExtrasPartnerTypesPage = lazy(() => import('./components/Extras/ExtrasPartnerTypesPage').then(m => ({ default: m.ExtrasPartnerTypesPage })));
const ExtrasPartnerCategoryTypesPage = lazy(() => import('./components/Extras/ExtrasPartnerCategoryTypesPage').then(m => ({ default: m.ExtrasPartnerCategoryTypesPage })));
const ExtrasPartnerRequestsPage = lazy(() => import('./components/Extras/ExtrasPartnerRequestsPage').then(m => ({ default: m.ExtrasPartnerRequestsPage })));
const ExtrasModule = lazy(() => import('./components/Extras/ExtrasModule').then(m => ({ default: m.ExtrasModule })));
import { AdminEvenementielConfig } from './components/Admin/AdminEvenementielConfig';
const AdminPlanningConfig = lazy(() => import('./components/Admin/AdminPlanningConfig').then(m => ({ default: m.AdminPlanningConfig })));
const AdminSettings = lazy(() => import('./components/Admin/AdminSettings'));
const AdminCollaboratorRequests = lazy(() => import('./components/Admin/AdminCollaboratorRequests').then(m => ({ default: m.AdminCollaboratorRequests })));
import { EmailsDuModule } from './components/Admin/EmailsDuModule';
const AdminExceptionServiceAutomationRequests = lazy(() => import('./components/Admin/AdminExceptionServiceAutomationRequests').then(m => ({ default: m.AdminExceptionServiceAutomationRequests })));
import { SendRegistrationModal } from './components/Admin/SendRegistrationModal';
const RegistrationRequestsView = lazy(() => import('./components/Admin/RegistrationRequestsView').then(m => ({ default: m.RegistrationRequestsView })));
import { ClientRegistrationForm } from './components/Public/ClientRegistrationForm';
import { BookingWidget } from './components/Public/BookingWidget';
import { RdvProBookingWidget } from './components/Public/RdvProBookingWidget';
import { MaReservationPage } from './components/Reservations/MaReservationPage';
const ReserverTablePage = lazy(() => import('./components/Reservations/EnLigne/ReserverTablePage').then(m => ({ default: m.ReserverTablePage })));
import { DemandeDevisPage } from './components/Public/DemandeDevisPage';
import { CentreNotifications, EVENEMENT_DEMANDES_ADMIN } from './components/ui/CentreNotifications';
import { DocumentationResponse } from './components/Public/DocumentationResponse';
import { EvenementielGuestPage } from './components/Public/EvenementielGuestPage';
import { OrganisateurPage } from './components/Public/Organisateur/OrganisateurPage';
import { TableCheckinPage } from './components/Public/TableCheckinPage';
import { SupplierOrderConfirmPage } from './components/Public/SupplierOrderConfirmPage';
import { RdvCancellationPage } from './components/Public/RdvCancellationPage';
import { MarketingUnsubscribePage } from './components/Public/MarketingUnsubscribePage';
import { ExtrasRequestConfirmPage } from './components/Public/ExtrasRequestConfirmPage';
import { DevisSignaturePage } from './components/Public/DevisSignaturePage';
import { PrestationDevisSignaturePage } from './components/Public/PrestationDevisSignaturePage';
import { PrestationReservationPage } from './components/Public/PrestationReservationPage';
import { EspaceClientPage } from './components/Public/EspaceClientPage';
import { MandatPrelevementPage } from './components/Public/MandatPrelevementPage';
import { ContractSignaturePage } from './components/Public/ContractSignaturePage';
import { AvisPage } from './components/Public/AvisPage';
import { PageNumberBadge } from './components/ui/PageNumberBadge';
import { PrestationsModule } from './components/Prestations/PrestationsModule';
import { PrestationPlanningModule } from './components/PrestationPlanning/PrestationPlanningModule';
const PubNewsletterModule = lazy(() => import('./components/Marketing/PubNewsletterModule').then(m => ({ default: m.PubNewsletterModule })));
const MaCarteModule = lazy(() => import('./components/MaCarte/MaCarteModule').then(m => ({ default: m.MaCarteModule })));
const MessagerieModule = lazy(() => import('./components/Messagerie/MessagerieModule').then(m => ({ default: m.MessagerieModule })));
const CartePublicPage = lazy(() => import('./components/Public/CartePublicPage').then(m => ({ default: m.CartePublicPage })));
const DemarchePubliquePage = lazy(() => import('./components/Public/DemarchePubliquePage').then(m => ({ default: m.DemarchePubliquePage })));
const SimulateurPublicPage = lazy(() => import('./components/Public/SimulateurPublicPage').then(m => ({ default: m.SimulateurPublicPage })));
const CarteRedirect = lazy(() => import('./components/Public/CartePublicPage').then(m => ({ default: m.CarteRedirect })));
const AvisModule = lazy(() => import('./components/Avis/AvisModule').then(m => ({ default: m.AvisModule })));
const PrestationEmployeeDashboard = lazy(() => import('./components/Employee/PrestationEmployeeDashboard').then(m => ({ default: m.PrestationEmployeeDashboard })));
import { SettingsPage } from './components/Settings/SettingsPage';
const PostesEmployesModule = lazy(() => import('./components/Employes/PostesEmployesModule').then(m => ({ default: m.PostesEmployesModule })));
const EmployeeProfilePage = lazy(() => import('./components/Employes/EmployeeProfilePage').then(m => ({ default: m.EmployeeProfilePage })));
import { ExceptionServiceModule } from './components/ExceptionService/ExceptionServiceModule';
import { PlanningTableView } from './components/Planning/PlanningTableView';
import { SupportModal } from './components/Support/SupportModal';
import { MessagesClientsView } from './components/Admin/MessagesClientsView';
import { InfoModal } from './components/InfoModal';
import { useTheme } from './hooks/useTheme';
const AdminFacturesPlateforme = lazy(() => import('./components/Admin/AdminFacturesPlateforme').then(m => ({ default: m.AdminFacturesPlateforme })));
const AdminTarifsModules = lazy(() => import('./components/Admin/AdminTarifsModules').then(m => ({ default: m.AdminTarifsModules })));
const AdminFormules = lazy(() => import('./components/Admin/AdminFormules').then(m => ({ default: m.AdminFormules })));
const AdminConseillereCouts = lazy(() => import('./components/Admin/AdminConseillereCouts').then(m => ({ default: m.AdminConseillereCouts })));
const AcceptationsConditions = lazy(() => import('./components/Admin/AcceptationsConditions').then(m => ({ default: m.AcceptationsConditions })));
const SentinelJournal = lazy(() => import('./components/Admin/SentinelJournal').then(m => ({ default: m.SentinelJournal })));
const SignaturesElectroniques = lazy(() => import('./components/Admin/SignaturesElectroniques').then(m => ({ default: m.SignaturesElectroniques })));
import { RHModule } from './components/RH/RHModule';
const EmployeeAbsences = lazy(() => import('./components/Employee/EmployeeAbsences').then(m => ({ default: m.EmployeeAbsences })));
const EmployeeSurveys = lazy(() => import('./components/Employee/EmployeeSurveys'));
const EmployeeOnboarding = lazy(() => import('./components/Employee/EmployeeOnboarding'));
const EmployeeExpenses = lazy(() => import('./components/Employee/EmployeeExpenses'));
const EmployeeTimeClock = lazy(() => import('./components/Employee/EmployeeTimeClock'));
const EmployeeMessages = lazy(() => import('./components/Employee/EmployeeMessages'));
import { PointageKiosque } from './components/Kiosque/PointageKiosque';
const TeamMessagingPage = lazy(() => import('./components/Employes/TeamMessagingPage'));
const NotesDeFraisPage = lazy(() => import('./components/Employes/NotesDeFraisPage'));
const PointageManagement = lazy(() => import('./components/Employes/PointageManagement'));
import { PublicHomepage } from './components/Public/PublicHomepage';
import { DemandesRecurrentesPage } from './components/Demandes/DemandesRecurrentesPage';
const CRMContactDemarchesPage = lazy(() => import('./components/CRM/CRMContactDemarchesPage'));
const CRMContactFacturesPage = lazy(() => import('./components/CRM/CRMContactFacturesPage'));
const CRMContactCommandesPage = lazy(() => import('./components/CRM/CRMContactCommandesPage'));
const CRMContactHistoriquePage = lazy(() => import('./components/CRM/CRMContactHistoriquePage'));

const SidebarItem = ({ icon: Icon, label, to, active, collapsed = false, badge }: any) => (
    <Link
        to={to}
        className={`group flex items-center ${collapsed ? 'justify-center' : 'gap-2'} ${collapsed ? 'px-0 py-1' : 'pl-2.5 pr-3 py-1.5'} rounded-lg transition-all relative ${
            active
                ? 'bg-brand-500/10 text-brand-700 dark:text-brand-300'
                : 'text-[var(--text-secondary)] hover:bg-brand-600/10 hover:text-brand-600 dark:hover:text-brand-400'
        }`}
        title={collapsed ? label : undefined}
    >
        {active && !collapsed && (
            <span className="absolute left-0 top-1.5 bottom-1.5 w-[3px] rounded-full bg-brand-500" />
        )}
        <span className={`inline-flex items-center justify-center ${collapsed ? 'w-8 h-8 rounded-lg group-hover:bg-[var(--interactive-hover)]' : 'w-5 h-5'} ${active && collapsed ? 'bg-brand-500/15 rounded-lg' : ''} transition-all relative`}>
            <Icon className="w-[18px] h-[18px] shrink-0" />
            {collapsed && badge !== undefined && badge > 0 && (
                <span className="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-1 rounded-full bg-red-500 text-content text-[9px] font-black flex items-center justify-center shadow-lg shadow-red-500/40 animate-pulse">
                    {badge > 99 ? '99+' : badge}
                </span>
            )}
        </span>
        {!collapsed && <span className={`text-[14px] min-w-0 truncate flex-1 ${active ? 'font-semibold' : 'font-medium'}`}>{label}</span>}
        {!collapsed && badge !== undefined && badge > 0 && (
            <span className="min-w-[20px] h-[20px] px-1.5 rounded-full bg-red-500 text-content text-[10px] font-black flex items-center justify-center shadow-lg shadow-red-500/30 animate-pulse">
                {badge > 99 ? '99+' : badge}
            </span>
        )}
    </Link>
);

// Groupe dépliable de SidebarItem (ex: "RH & équipe" regroupant Postes & Employés + Demande de congé(s)) —
// replié par défaut sauf si la page actuellement affichée fait partie du groupe (jamais "perdu" en arrivant
// sur une page dont la catégorie serait repliée). Quand la sidebar entière est réduite à la barre d'icônes
// (collapsed=true), le regroupement n'a plus de sens visuel : on retombe simplement sur la liste à plat.
// Groupe « Commerciaux » : une page par usage (refonte 2026-10-23). La direction voit Ventes, Commerciaux et Challenges ; un commercial
// voit seulement « Mes ventes » (ses dossiers, ses commissions, son code vendeur). Les réglages sont dans Paramètres > Commerciaux.
const MenuCommerciaux: React.FC<{ collapsed: boolean }> = ({ collapsed }) => {
    const { moi, direction } = useMoiCommerciaux();
    const chemin = window.location.pathname;
    return (
        <SidebarCategory icon={UserCheck} label="Commerciaux" collapsed={collapsed} defaultOpen={chemin.startsWith('/commerciaux') || chemin === '/prospects'}>
            <SidebarItem icon={Briefcase} label={moi && !direction ? 'Mes ventes' : 'Ventes'} to="/commerciaux" active={chemin === '/commerciaux'} collapsed={collapsed} />
            {direction && <SidebarItem icon={Users} label="Commerciaux" to="/commerciaux/equipe" active={chemin === '/commerciaux/equipe'} collapsed={collapsed} />}
            <SidebarItem icon={MapPin} label={moi && !direction ? 'Mes prospects' : 'Prospects'} to="/prospects" active={chemin === '/prospects'} collapsed={collapsed} />
            {direction && <SidebarItem icon={Trophy} label="Challenges" to="/commerciaux/challenges" active={chemin === '/commerciaux/challenges'} collapsed={collapsed} />}
        </SidebarCategory>
    );
};

const SidebarCategory = ({ icon: Icon, label, collapsed = false, defaultOpen = false, badge, children }: any) => {
    const [open, setOpen] = useState(defaultOpen);
    if (collapsed) return <>{children}</>;
    return (
        <div>
            <button
                onClick={() => setOpen((v) => !v)}
                className="w-full flex items-center gap-2 pl-2.5 pr-3 py-1.5 rounded-lg transition-all text-[var(--text-secondary)] hover:bg-brand-600/10 hover:text-brand-600 dark:hover:text-brand-400"
            >
                <span className="inline-flex items-center justify-center w-5 h-5"><Icon className="w-[18px] h-[18px] shrink-0" /></span>
                <span className="text-[13px] min-w-0 truncate flex-1 text-left font-bold uppercase tracking-wide">{label}</span>
                {badge !== undefined && badge > 0 && (
                    <span className="min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-content text-[9px] font-black flex items-center justify-center shrink-0">
                        {badge > 99 ? '99+' : badge}
                    </span>
                )}
                <ChevronDown size={14} className={`shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
            </button>
            {open && (
                <div className="ml-3 pl-2.5 border-l border-[var(--border-color)] space-y-0.5 mt-0.5 mb-0.5">
                    {children}
                </div>
            )}
        </div>
    );
};

const ModuleTracker = () => {
    const location = useLocation();
    const { user } = useAuth();
    const lastPathRef = React.useRef(location.pathname);

    React.useEffect(() => {
        if (!user || user.type === 'admin') return;
        
        const path = location.pathname;
        if (path === lastPathRef.current) return;
        
        const modules: Record<string, string> = {
            '/planning': 'Planning',
            '/evenementiel': 'Événementiel',
            '/factures': 'Facturation',
            '/crm': 'CRM',
            '/employes': 'Gestion Staff',
            '/demandes-conges': 'Demande de congé(s)'
        };
        
        const moduleName = modules[path as keyof typeof modules];
        if (moduleName) {
            adminApi.logAction({
                action: 'MODULE_VISIT',
                category: 'METIER',
                message: `A consulté le module : ${moduleName}`
            }).catch(() => {});
        }
        
        lastPathRef.current = path;
    }, [location.pathname, user]);

    return null;
};

// Tout l'espace connecté passe par la barrière d'acceptation des conditions d'utilisation (2026-10-14).
const Layout = ({ children }: any) => (
    <TermsGate><LayoutInner>{children}</LayoutInner></TermsGate>
);

const LayoutInner = ({ children }: any) => {
    const { user, logout, refreshUser, loading } = useAuth();
    const { theme, toggleTheme } = useTheme();
    const navigate = useNavigate();
    const location = useLocation();

    React.useEffect(() => {
        if (!loading) {
            if (!user) {
                // Garde l'URL demandée (ex: un lien de booking d'extras avec ?bookEvent=...) pour y revenir
                // après connexion, au lieu de toujours retomber sur le tableau de bord par défaut — demande
                // d'Emeni (2026-08-22) : "la personne à qui j'envoie le lien doit être connectée pour accéder
                // à la privat concernée pour booker".
                navigate('/login', { state: { from: `${location.pathname}${location.search}` } });
            } else if (user.type === 'employe' && window.location.pathname !== '/planning' && window.location.pathname !== '/absences' && window.location.pathname !== '/parametres' && window.location.pathname !== '/mon-tableau-de-bord' && window.location.pathname !== '/mes-sondages' && window.location.pathname !== '/mon-integration' && window.location.pathname !== '/mes-notes-de-frais' && window.location.pathname !== '/pointage' && window.location.pathname !== '/mes-messages') {
                navigate('/planning');
            }
        }
    }, [user, loading, navigate]);

    const [activeModules, setActiveModules] = React.useState<string[]>([]);
    // Vrai quand le serveur a renvoyé au moins une ligne de module pour cet établissement (même inactive) :
    // la liste fait alors foi, même vide. Faux = ancien compte jamais configuré, qui retombe sur le jeton.
    const [modulesConfigures, setModulesConfigures] = React.useState(false);
    const { moduleVisible } = useOrganisation();
    // Nombre de demandes d'accès à traiter, affiché en pastille sur « Mon équipe » (direction seulement).
    const [demandesEnAttente, setDemandesEnAttente] = React.useState(0);
    React.useEffect(() => {
        if (user?.type !== 'client') return undefined;
        let vivant = true;
        equipeApi().demandes().then((r) => { if (vivant) setDemandesEnAttente(r.demandes.filter((d) => d.status === 'en_attente').length); }).catch(() => {});
        return () => { vivant = false; };
    }, [user?.type, location.pathname]);
    const [isCollapsed, setIsCollapsed] = React.useState(() => {
        try {
            const saved = localStorage.getItem('sidebarCollapsed');
            return saved === '1';
        } catch {
            return false;
        }
    });
    const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
    // Referme le menu burger mobile après un clic sur un lien de la sidebar — sans ça, le menu (et son
    // overlay sombre plein écran) restait ouvert par-dessus la page de destination, donnant l'impression que
    // la navigation avait échoué ou que l'appli était bloquée sur mobile. Demande d'Emeni (2026-08-22, audit
    // responsive mobile/tablette).
    React.useEffect(() => { setIsMobileMenuOpen(false); }, [location.pathname]);
    const [supportUnreadCount, setSupportUnreadCount] = React.useState(0);
    const [showSupportModal, setShowSupportModal] = React.useState(false);
    const [clientSupportUnreadCount, setClientSupportUnreadCount] = React.useState(0);
    const [pendingAbsenceCount, setPendingAbsenceCount] = React.useState(0);
    const [pendingCollabRequestCount, setPendingCollabRequestCount] = React.useState(0);
    // Demandes des clients en attente de décision du super-admin, par page du menu (envoyées par la cloche à chaque rafraîchissement).
    const [demandesAdmin, setDemandesAdmin] = React.useState<Record<string, number>>({});
    React.useEffect(() => {
        const surCompteurs = (e: Event) => setDemandesAdmin((e as CustomEvent).detail || {});
        window.addEventListener(EVENEMENT_DEMANDES_ADMIN, surCompteurs);
        return () => window.removeEventListener(EVENEMENT_DEMANDES_ADMIN, surCompteurs);
    }, []);
    const nbDemandes = (chemin: string) => Number(demandesAdmin[chemin]) || 0;
    const totalDemandesClients = Object.values(demandesAdmin).reduce((a: number, b) => a + (Number(b) || 0), 0);
    const [conseillereAttente, setConseillereAttente] = React.useState(0);
    const [pendingBookingRequestCount, setPendingBookingRequestCount] = React.useState(0);
    const [nextPendingBookingRequest, setNextPendingBookingRequest] = React.useState<{ id: string; date: string } | null>(null);
    const [myMessagesUnreadCount, setMyMessagesUnreadCount] = React.useState(0);
    const [teamMessagesUnreadCount, setTeamMessagesUnreadCount] = React.useState(0);
    const [pendingExpenseCount, setPendingExpenseCount] = React.useState(0);

    React.useEffect(() => {
        try {
            localStorage.setItem('sidebarCollapsed', isCollapsed ? '1' : '0');
        } catch {}
    }, [isCollapsed]);

    const resolvedLogoUrl = resolveLogoUrl(user?.logoUrl);

    const loadModules = React.useCallback(async () => {
        try {
            const modules = await authApi.getMyModules();
            const actifs = modules.filter((m: any) => m.is_active === 1).map((m: any) => m.module_name);
            setActiveModules(actifs);
            setModulesConfigures(modules.length > 0);
            if (modules.length > 0 && actifs.length === 0) {
                console.error("[L'IAmani] Service momentanément indisponible (503). Veuillez réessayer ultérieurement.");
            }
        } catch (e) {
            console.error('Failed to load active modules', e);
        }
    }, []);

    // « Mes modules » (L01) : un module activé ou désactivé là-bas apparaît tout de suite dans la barre latérale.
    React.useEffect(() => {
        const recharger = () => { void loadModules(); };
        window.addEventListener('iamani:modules-changed', recharger);
        return () => window.removeEventListener('iamani:modules-changed', recharger);
    }, [loadModules]);

    // Ne déconnecte QUE sur un refus explicite du serveur (401/403) — même règle que verifyToken dans
    // AuthContext. Auparavant le catch était aveugle : n'importe quelle erreur réseau déconnectait, et comme
    // apiFetch abandonne une requête au bout de 10 s sans jamais retenter un AbortError, une 4G lente ou une
    // requête gelée par iOS (Safari suspend les timers quand le Trousseau passe au premier plan pendant la
    // connexion) renvoyait l'utilisateur sur /login juste après une connexion pourtant réussie. Signalé par
    // Emeni (2026-08-23) : impossible de se connecter depuis un téléphone.
    const checkStatus = React.useCallback(async () => {
        try {
            const me = await authApi.getMe();
            if (me.status === 'blocked') {
                logout();
                navigate('/login');
            }
        } catch (e: any) {
            const isAuthRejection = e?.status === 401 || e?.status === 403
                || (e?.message && /401|403|Forbidden|Unauthorized|Session expirée/.test(e.message));
            if (isAuthRejection) {
                logout();
                navigate('/login');
            } else {
                console.warn('checkStatus: erreur réseau ignorée, session conservée', e);
            }
        }
    }, [logout, navigate]);

    React.useEffect(() => {
        if (user && user.type !== 'admin') {
            loadModules();
            checkStatus();
        }
    }, [user, loadModules, checkStatus]);

    const refreshClientUnreadCount = React.useCallback(async () => {
        if (user && user.type !== 'admin' && (activeModules.length === 0 || activeModules.includes('support'))) {
            try {
                const data = await supportApi.getClientUnreadCount();
                setClientSupportUnreadCount(Number(data?.count || 0));
            } catch {}
        }
    }, [user, activeModules]);

    React.useEffect(() => {
        if (!user) return;
        let mounted = true;
        const controller = new AbortController();

        const loadUnread = async () => {
            try {
                if (user.type === 'admin') {
                    const data = await supportApi.getAdminUnreadCount();
                    if (mounted) setSupportUnreadCount(Number(data?.count || 0));
                    try {
                        const reqs = await adminApi.getCollaboratorRequests();
                        // La pastille compte aussi les demandes de places de comptes (palier atteint).
                        const places = await abonnementsApi.demandesPlaces().then((r) => r.demandes.length).catch(() => 0);
                        if (Array.isArray(reqs)) {
                            const count = reqs.filter((r: any) => r.status === 'pending').length + places;
                            if (mounted) setPendingCollabRequestCount(count);
                        }
                    } catch {}
                } else {
                    if (activeModules.length === 0 || activeModules.includes('support')) {
                        const data = await supportApi.getClientUnreadCount();
                        if (mounted) setClientSupportUnreadCount(Number(data?.count || 0));
                    }

                    if (user.type !== 'employe' && activeModules.includes('demande_conges')) {
                        try {
                            const token = localStorage.getItem('token');
                            const reqs = await fetch('/api/absence-requests', {
                                headers: { Authorization: `Bearer ${token}` },
                                signal: controller.signal
                            }).then(r => r.json());
                            if (Array.isArray(reqs)) {
                                const count = reqs.filter((r: any) => r.status === 'pending').length;
                                if (mounted) setPendingAbsenceCount(count);
                            }
                        } catch {}
                    } else if (user.type === 'employe') {
                        try {
                            const data: any = await moduleApi.getMyAnnouncementsUnreadCount();
                            if (mounted) setMyMessagesUnreadCount(Number(data?.count || 0));
                        } catch {}
                    }
                }
            } catch (e: any) {
                // Silently ignore AbortError — it's expected on cleanup/navigation
                if (e?.name === 'AbortError' || e instanceof DOMException) return;
            }
        };
        loadUnread();
        // 60s interval — checking every minute is more than sufficient for unread count
        const timer = setInterval(loadUnread, 60000);

        // Immediate refresh when an action occurs (e.g. accepted/refused/submitted)
        window.addEventListener('absenceRequestProcessed', loadUnread);
        window.addEventListener('collaboratorRequestProcessed', loadUnread);

        return () => {
            mounted = false;
            controller.abort();
            clearInterval(timer);
            window.removeEventListener('absenceRequestProcessed', loadUnread);
            window.removeEventListener('collaboratorRequestProcessed', loadUnread);
        };
    }, [user, activeModules]);

    // Bulle rouge sur l'entrée "Planning" (client Prestation) : nombre de demandes de réservation en ligne
    // en attente de validation (widget public /reserver/:clientId).
    React.useEffect(() => {
        if (!user || user.type === 'admin' || user.type === 'employe' || user.client_type !== 'prestation' || !activeModules.includes('planning_rdv')) return;
        let mounted = true;
        const loadPendingBookingCount = async () => {
            try {
                const data = await moduleApi.getPrestationPendingRequestsCount();
                if (mounted) {
                    setPendingBookingRequestCount(Number(data?.count || 0));
                    setNextPendingBookingRequest(data?.next_id && data?.next_date ? { id: data.next_id, date: data.next_date } : null);
                }
            } catch {}
        };
        loadPendingBookingCount();
        const timer = setInterval(loadPendingBookingCount, 60000);
        window.addEventListener('prestationBookingRequestProcessed', loadPendingBookingCount);
        return () => {
            mounted = false;
            clearInterval(timer);
            window.removeEventListener('prestationBookingRequestProcessed', loadPendingBookingCount);
        };
    }, [user, activeModules]);

    // Pastille rouge sur « Messagerie clients » : conversations de la Conseillère IA qui attendent une réponse
    // de l'équipe (l'assistante a passé la main, ou le visiteur a écrit depuis la dernière réponse). Rafraîchie
    // toutes les 30 s, et tout de suite quand l'écran des conversations répond, clôture ou lit.
    // Alerte super-admin : la partie gratuite de l'IA (10 000 neurones par jour) approche de sa fin ou est dépassée → pastille sur « Coûts IA ».
    const [alerteIaNiveau, setAlerteIaNiveau] = React.useState(0);
    React.useEffect(() => {
        if (!user || user.type !== 'admin') return;
        let mounted = true;
        const charger = () => { conseillereAdminApi.alerte().then((r) => { if (mounted) setAlerteIaNiveau(Number(r?.niveau || 0)); }).catch(() => undefined); };
        charger();
        const timer = setInterval(charger, 300000);
        return () => { mounted = false; clearInterval(timer); };
    }, [user]);
    const conseillereActive = !!user && user.type !== 'admin' && activeModules.includes('conseillere_ia');
    React.useEffect(() => {
        if (!conseillereActive) { setConseillereAttente(0); return; }
        let mounted = true;
        const charger = async () => {
            try {
                const r = await conseillereApi.badge();
                if (mounted) setConseillereAttente(Number(r?.en_attente || 0));
            } catch {}
        };
        charger();
        const timer = setInterval(charger, 30000);
        window.addEventListener('conseillereConversationsChanged', charger);
        return () => {
            mounted = false;
            clearInterval(timer);
            window.removeEventListener('conseillereConversationsChanged', charger);
        };
    }, [conseillereActive]);

    // Bulles rouges sur la nouvelle entrée sidebar "Messagerie" (messages d'équipe non lus + notes de
    // frais en attente) — même principe que pendingAbsenceCount, mais regroupées pour cette catégorie.
    React.useEffect(() => {
        if (!user || user.type === 'admin' || user.type === 'employe' || !activeModules.includes('portail_salarie')) return;
        let mounted = true;
        const loadMessagerieCounts = async () => {
            try {
                const data: any = await moduleApi.getTeamAnnouncementsUnreadCount();
                if (mounted) setTeamMessagesUnreadCount(Number(data?.count || 0));
            } catch {}
            try {
                const reports = await moduleApi.getExpenseReports();
                if (mounted && Array.isArray(reports)) setPendingExpenseCount(reports.filter((r: any) => r.status === 'pending').length);
            } catch {}
        };
        loadMessagerieCounts();
        const timer = setInterval(loadMessagerieCounts, 60000);
        return () => {
            mounted = false;
            clearInterval(timer);
        };
    }, [user, activeModules]);

    // Rôle du commercial lu AVANT les retours anticipés : un hook ne peut jamais être conditionnel.
    const moiCommercial = useMoiCommerciaux(user?.type === 'collaborator');
    const commercialSeul = moiCommercial.moi?.role === 'commercial';
    if (loading) return null;
    if (!user) return null;

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    // Compte commercial (module Commerciaux) : uniquement estimation, dossiers de ses clients et ses ventes. Ni catalogue et prix, ni planning, ni
    // fichier clients, ni commissions de l'équipe, ni notifications de l'établissement (2026-10-23, Emeni).
    const CHEMINS_COMMERCIAL = ['/', '/suivi-prestation', '/estimation-devis', '/commerciaux', '/prospects', '/parametres', '/support'];
    const hors = commercialSeul && !CHEMINS_COMMERCIAL.some((p) => (p === '/' ? location.pathname === '/' : location.pathname === p || location.pathname.startsWith(`${p}/`)));

    const isModuleActive = (name: string) => {
        if (!user) return false;
        if (user.type === 'admin') return false; // Admin uses a separate hardcoded section
        // Plusieurs services : seuls les modules du service choisi (et les modules transverses) s'affichent.
        if (!moduleVisible(name)) return false;
        if (commercialSeul && !['dashboard', 'support', 'suivi_prestation', 'commerciaux'].includes(name)) return false;
        if (modulesConfigures) return activeModules.includes(name); // la liste du serveur fait foi, même vide
        
        // Dashboard et Support se coupent depuis le provisioning : pendant le chargement de la liste on les
        // montre (un établissement qui les a ne doit pas les voir clignoter), la liste serveur tranche ensuite.
        if (activeModules.length === 0 && (name === 'dashboard' || name === 'support')) return true;

        // 1. Check live modules fetched from server (most accurate)
        if (activeModules.length > 0) {
            return activeModules.includes(name);
        }

        // 2. Fallback to JWT permissions (immediate display during loading)
        const jwtModules = (user as any).modules || user.modules_access || [];
        return jwtModules.includes(name);
    };

    return (
        <div
            className="flex min-h-screen bg-[var(--bg-app)] text-[var(--text-primary)] transition-colors duration-300"
            style={{ '--sidebar-w': isCollapsed ? '72px' : '248px' } as React.CSSProperties}
        >
            {/* Ambiance de la plateforme : recolore l'accent de la coquille connectée (jamais les widgets ni le kiosque) */}
            <AmbianceAccent />
            {user && user.type !== 'admin' && <ModuleTracker />}
            
            {/* Overlay Mobile */}
            {isMobileMenuOpen && (
                <div 
                    className="fixed inset-0 bg-black/60 z-40 md:hidden" 
                    onClick={() => setIsMobileMenuOpen(false)}
                />
            )}

            {/* Sidebar */}
            <motion.aside
                animate={{ width: isCollapsed ? 72 : 248 }}
                transition={{ duration: 0.25, ease: 'easeInOut' }}
                // min-w-0 + overflow-hidden : sans eux, la règle flex `min-width:auto` donne à la barre la
                // largeur minimale de son CONTENU, et le nom de l'établissement affiché en gros caractères
                // l'emportait sur le width animé ci-dessus — « Le Petit Cageot SARL » l'étirait à 464px au
                // lieu de 248, volant plus de 200px à toutes les pages sur un écran d'ordinateur. Signalé par
                // Emeni (2026-08-24) : "certaines pages ne prennent pas toute la page en version PC".
                className={`bg-[var(--bg-sidebar)] border-r border-[var(--border-color)] p-3 md:p-4 flex flex-col h-screen fixed md:sticky top-0 z-50 min-w-0 overflow-hidden transition-transform duration-300 md:translate-x-0 ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}
            >
                <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'justify-between'} mb-2 shrink-0`}>
                    <div className={`flex items-center ${isCollapsed ? '' : 'gap-2'} px-2`}>
                        <div className="w-7 h-7 bg-white rounded-lg flex items-center justify-center overflow-hidden">
                            {resolvedLogoUrl ? (
                                <img
                                    src={resolvedLogoUrl}
                                    alt={user?.company_name || 'Logo client'}
                                    className="w-full h-full object-cover"
                                    onError={(e) => {
                                        (e.currentTarget as HTMLImageElement).style.display = 'none';
                                    }}
                                />
                            ) : (
                                <ShieldCheck className="text-content" size={20} />
                            )}
                        </div>
                        {!isCollapsed && (
                            user?.type === 'employe' ? (
                                <div className="flex flex-col justify-center ml-1">
                                    <span className="font-black text-[15px] leading-none text-content">{user?.name}</span>
                                    <span className="text-[10px] text-content-muted font-bold uppercase tracking-wider mt-0.5">{user?.company_name}</span>
                                </div>
                            ) : (
                                // Taille dégressive selon la longueur du nom : 36px convient à « L'IAmani »,
                                // pas à « Le Petit Cageot SARL » qui débordait de la barre. Le nom reste
                                // affiché en entier (retour à la ligne), simplement dans une taille qui tient
                                // dans les 248px de la barre.
                                <span
                                    className="font-bold leading-none tracking-tight text-slate-700 dark:text-[var(--text-primary)] break-words min-w-0"
                                    style={{ fontSize: (() => {
                                        const n = (user?.company_name || "L'IAmani").length;
                                        return n <= 10 ? 32 : n <= 16 ? 26 : n <= 24 ? 21 : 18;
                                    })() }}
                                >{user?.company_name || "L'IAmani"}</span>
                            )
                        )}
                    </div>
                    {!isCollapsed && (
                        <button
                            onClick={() => setIsCollapsed((prev) => !prev)}
                            className="p-1.5 rounded-lg text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--interactive-hover)] transition-all"
                            aria-label="Réduire la barre latérale"
                        >
                            <ChevronRight className={`${isCollapsed ? 'rotate-180' : ''} transition-transform`} size={16} />
                        </button>
                    )}
                </div>

                {isCollapsed && (
                    <button
                        onClick={() => setIsCollapsed((prev) => !prev)}
                        className="mb-3 p-1.5 rounded-lg text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--interactive-hover)] transition-all mx-auto"
                        aria-label="Étendre la barre latérale"
                    >
                        <ChevronRight className={`${isCollapsed ? 'rotate-180' : ''} transition-transform`} size={16} />
                    </button>
                )}

                <SelecteurContexte collapsed={isCollapsed} />

                <nav className="flex-1 space-y-0.5 overflow-y-auto min-h-0 sidebar-nav-scroll">
                    {user?.type !== 'employe' && isModuleActive('dashboard') && (
                        <SidebarItem icon={LayoutDashboard} label={commercialSeul ? 'Accueil' : 'Dashboard'} to="/" active={window.location.pathname === '/'} collapsed={isCollapsed} />
                    )}
                    
                    {user?.type === 'employe' ? (
                        <>
                            {!isCollapsed && <div className="mt-3 mb-1 px-3 text-[9px] font-bold text-slate-600 dark:text-content-muted uppercase tracking-widest">Espace Salarié</div>}
                            {user?.client_type === 'prestation' && isModuleActive('portail_salarie') && <SidebarItem icon={LayoutDashboard} label="Dashboard" to="/mon-tableau-de-bord" active={window.location.pathname === '/mon-tableau-de-bord'} collapsed={isCollapsed} />}
                            {isModuleActive('portail_salarie') && <SidebarItem icon={Calendar} label="Mon Planning" to="/planning" active={window.location.pathname === '/planning'} collapsed={isCollapsed} />}
                            {isModuleActive('demande_conges') && <SidebarItem icon={Clock} label="Mes Demandes" to="/absences" active={window.location.pathname === '/absences'} collapsed={isCollapsed} />}
                            {isModuleActive('portail_salarie') && <SidebarItem icon={ClipboardList} label="Sondages" to="/mes-sondages" active={window.location.pathname === '/mes-sondages'} collapsed={isCollapsed} />}
                            {isModuleActive('portail_salarie') && <SidebarItem icon={ListChecks} label="Mon intégration" to="/mon-integration" active={window.location.pathname === '/mon-integration'} collapsed={isCollapsed} />}
                            {isModuleActive('portail_salarie') && <SidebarItem icon={Receipt} label="Notes de frais" to="/mes-notes-de-frais" active={window.location.pathname === '/mes-notes-de-frais'} collapsed={isCollapsed} />}
                            {isModuleActive('portail_salarie') && user?.time_clock_enabled !== false && <SidebarItem icon={Clock} label="Pointage" to="/pointage" active={window.location.pathname === '/pointage'} collapsed={isCollapsed} />}
                            {isModuleActive('portail_salarie') && <SidebarItem icon={MessageSquare} label="Messages" to="/mes-messages" active={window.location.pathname === '/mes-messages'} collapsed={isCollapsed} badge={myMessagesUnreadCount} />}
                        </>
                    ) : user?.type === 'admin' || user?.role === 'superadmin' ? (
                        <>
                            {/* Réorganisée le 2026-10-29 (Emeni : « je me perds trop ») : une quinzaine d'entrées à plat,
                                rangées maintenant par tâche. Chaque groupe s'ouvre tout seul quand la page affichée en fait partie. */}
                            <SidebarCategory icon={Users} label="Clients" collapsed={isCollapsed} badge={Math.max(totalDemandesClients, pendingCollabRequestCount)}
                                defaultOpen={['/admin/clients', '/admin/integration', '/admin/groupes', '/admin/registration-requests', '/admin/demandes-modules', '/admin/poles-groupe', '/admin/collaborator-requests', '/admin/exception-service-automation-requests'].some((p) => window.location.pathname.startsWith(p))}>
                                <SidebarItem icon={Users} label="Gestion Clients" to="/admin/clients" active={window.location.pathname.startsWith('/admin/clients')} collapsed={isCollapsed} />
                                <SidebarItem icon={ClipboardCheck} label="Intégration des clients" to="/admin/integration" active={window.location.pathname.startsWith('/admin/integration')} collapsed={isCollapsed} />
                                <SidebarItem icon={Network} label="Groupes d'établissements" to="/admin/groupes" active={window.location.pathname === '/admin/groupes'} collapsed={isCollapsed} />
                                <SidebarItem icon={Inbox} label="Demandes de modules" to="/admin/demandes-modules" active={window.location.pathname === '/admin/demandes-modules'} collapsed={isCollapsed} badge={nbDemandes('/admin/demandes-modules')} />
                                <SidebarItem icon={UserPlus} label="Demandes d'inscription" to="/admin/registration-requests" active={window.location.pathname === '/admin/registration-requests'} collapsed={isCollapsed} badge={nbDemandes('/admin/registration-requests')} />
                                <SidebarItem icon={Network} label="Pôles et groupe" to="/admin/poles-groupe" active={window.location.pathname === '/admin/poles-groupe'} collapsed={isCollapsed} badge={nbDemandes('/admin/poles-groupe')} />
                                <SidebarItem icon={UserPlus} label="Demandes Collaborateurs" to="/admin/collaborator-requests" active={window.location.pathname === '/admin/collaborator-requests'} collapsed={isCollapsed} badge={Math.max(nbDemandes('/admin/collaborator-requests'), pendingCollabRequestCount)} />
                                <SidebarItem icon={Zap} label="Demandes d'automatisation" to="/admin/exception-service-automation-requests" active={window.location.pathname === '/admin/exception-service-automation-requests'} collapsed={isCollapsed} badge={nbDemandes('/admin/exception-service-automation-requests')} />
                            </SidebarCategory>
                            <SidebarCategory icon={MessageSquare} label="Communication" collapsed={isCollapsed} badge={supportUnreadCount}
                                defaultOpen={['/admin/support', '/admin/messages-clients'].some((p) => window.location.pathname.startsWith(p))}>
                                <SidebarItem icon={MessageSquare} label="Support client" to="/admin/support" active={window.location.pathname === '/admin/support'} collapsed={isCollapsed} badge={supportUnreadCount} />
                                <SidebarItem icon={Send} label="Créer un message" to="/admin/messages-clients" active={window.location.pathname === '/admin/messages-clients'} collapsed={isCollapsed} />
                            </SidebarCategory>
                            <SidebarCategory icon={FileText} label="Facturation" collapsed={isCollapsed} badge={alerteIaNiveau > 0 ? 1 : 0}
                                defaultOpen={['/admin/tarifs-modules', '/admin/formules', '/admin/factures-plateforme', '/admin/couts-ia'].some((p) => window.location.pathname.startsWith(p))}>
                                <SidebarItem icon={Tag} label="Tarifs des modules" to="/admin/tarifs-modules" active={window.location.pathname === '/admin/tarifs-modules'} collapsed={isCollapsed} />
                                <SidebarItem icon={Layers} label="Formules" to="/admin/formules" active={window.location.pathname === '/admin/formules'} collapsed={isCollapsed} />
                                <SidebarItem icon={FileText} label="Factures plateforme" to="/admin/factures-plateforme" active={window.location.pathname === '/admin/factures-plateforme'} collapsed={isCollapsed} />
                                <SidebarItem icon={Bot} label="Coûts IA" to="/admin/couts-ia" active={window.location.pathname === '/admin/couts-ia'} collapsed={isCollapsed} badge={alerteIaNiveau > 0 ? 1 : 0} />
                            </SidebarCategory>
                            <SidebarCategory icon={ShieldCheck} label="Conformité" collapsed={isCollapsed}
                                defaultOpen={['/admin/sentinel', '/admin/conditions', '/admin/signatures'].some((p) => window.location.pathname.startsWith(p))}>
                                <SidebarItem icon={ShieldAlert} label="Journal Sentinel" to="/admin/sentinel" active={window.location.pathname === '/admin/sentinel'} collapsed={isCollapsed} />
                                <SidebarItem icon={ShieldCheck} label="Acceptations des CGU" to="/admin/conditions" active={window.location.pathname === '/admin/conditions'} collapsed={isCollapsed} />
                                <SidebarItem icon={FileSignature} label="Signatures électroniques" to="/admin/signatures" active={window.location.pathname === '/admin/signatures'} collapsed={isCollapsed} />
                            </SidebarCategory>
                            <SidebarCategory icon={Briefcase} label="Mon activité" collapsed={isCollapsed}
                                defaultOpen={['/rdv-pro', '/crm', '/ma-carte', '/messagerie-clients'].some((p) => window.location.pathname.startsWith(p))}>
                                <SidebarItem icon={CalendarCheck} label="RDV Pro" to="/rdv-pro" active={window.location.pathname === '/rdv-pro'} collapsed={isCollapsed} />
                                <SidebarItem icon={Users} label="CRM Contacts" to="/crm" active={window.location.pathname === '/crm'} collapsed={isCollapsed} />
                                <SidebarItem icon={QrCode} label="Ma Carte" to="/ma-carte" active={window.location.pathname === '/ma-carte'} collapsed={isCollapsed} />
                                <SidebarItem icon={MessageSquare} label="Messagerie clients" to="/messagerie-clients" active={window.location.pathname === '/messagerie-clients'} collapsed={isCollapsed} />
                            </SidebarCategory>
                        </>
                    ) : (
                        <>
                            {!isCollapsed && <div className="mt-3 mb-1 px-3 text-[9px] font-bold text-slate-600 dark:text-content-muted uppercase tracking-widest">Mes Modules</div>}
                            {user?.client_type === 'fournisseur' ? (
                                <>
                                    {/* Compte fournisseur (2026-10-29) : un menu à part, court. Il grandira avec ses commandes reçues, ses clients et sa livraison. */}
                                    {isModuleActive('catalogue_fournisseur') && <SidebarItem icon={Package} label="Mon catalogue" to="/mon-catalogue" active={window.location.pathname === '/mon-catalogue'} collapsed={isCollapsed} />}
                                    {isModuleActive('commandes_recues') && <SidebarItem icon={ClipboardList} label="Commandes reçues" to="/commandes-recues" active={window.location.pathname === '/commandes-recues'} collapsed={isCollapsed} />}
                                    {isModuleActive('prix_clients') && <SidebarItem icon={Users} label="Mes clients" to="/mes-clients" active={window.location.pathname === '/mes-clients'} collapsed={isCollapsed} />}
                                    {isModuleActive('commandes_recues') && <SidebarItem icon={MessageSquare} label="Demandes de devis" to="/demandes" active={window.location.pathname === '/demandes'} collapsed={isCollapsed} />}
                                    {isModuleActive('commandes_recues') && <SidebarItem icon={Truck} label="Mon profil public" to="/mon-profil-public" active={window.location.pathname === '/mon-profil-public'} collapsed={isCollapsed} />}
                                    {isModuleActive('commandes_recues') && <SidebarItem icon={Truck} label="Ma livraison" to="/ma-livraison" active={window.location.pathname === '/ma-livraison'} collapsed={isCollapsed} />}
                                    {isModuleActive('crm') && <SidebarItem icon={Users} label="Contacts" to="/crm" active={window.location.pathname.startsWith('/crm')} collapsed={isCollapsed} />}
                                    {isModuleActive('facture') && <SidebarItem icon={FileText} label="Factures" to="/factures" active={window.location.pathname === '/factures'} collapsed={isCollapsed} />}
                                    {isModuleActive('achats') && <SidebarItem icon={ShoppingBag} label="Achats" to="/achats" active={window.location.pathname === '/achats'} collapsed={isCollapsed} />}
                                    {isModuleActive('employes') && <SidebarItem icon={Users} label="Postes & Employés" to="/employes" active={window.location.pathname === '/employes'} collapsed={isCollapsed} />}
                                </>
                            ) : user?.client_type === 'prestation' ? (
                                <>
                                    {(isModuleActive('employes') || isModuleActive('portail_salarie')) && (
                                        <SidebarCategory icon={Users} label="RH & équipe" collapsed={isCollapsed} defaultOpen={['/employes', '/pointage-admin'].includes(window.location.pathname)}>
                                            {isModuleActive('employes') && <SidebarItem icon={Users} label="Postes & Employés" to="/employes" active={window.location.pathname === '/employes'} collapsed={isCollapsed} />}
                                            {isModuleActive('portail_salarie') && <SidebarItem icon={Clock} label="Pointage" to="/pointage-admin" active={window.location.pathname === '/pointage-admin'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {(isModuleActive('demande_conges') || isModuleActive('portail_salarie')) && (
                                        <SidebarCategory icon={MessageSquare} label="Messagerie" collapsed={isCollapsed} defaultOpen={['/messagerie', '/notes-de-frais', '/demandes-conges'].includes(window.location.pathname)} badge={pendingAbsenceCount + teamMessagesUnreadCount + pendingExpenseCount}>
                                            {isModuleActive('portail_salarie') && <SidebarItem icon={MessageSquare} label="Messages" to="/messagerie" active={window.location.pathname === '/messagerie'} collapsed={isCollapsed} badge={teamMessagesUnreadCount} />}
                                            {isModuleActive('portail_salarie') && <SidebarItem icon={Receipt} label="Notes de frais" to="/notes-de-frais" active={window.location.pathname === '/notes-de-frais'} collapsed={isCollapsed} badge={pendingExpenseCount} />}
                                            {isModuleActive('demande_conges') && <SidebarItem icon={Users} label="Demande de congé(s)" to="/demandes-conges" active={window.location.pathname === '/demandes-conges'} collapsed={isCollapsed} badge={pendingAbsenceCount} />}
                                        </SidebarCategory>
                                    )}
                                    {(isModuleActive('prestations') || isModuleActive('suivi_prestation')) && (
                                        <SidebarCategory icon={Package} label={commercialSeul ? 'Mes clients' : 'Prestations & devis'} collapsed={isCollapsed} defaultOpen={['/prestations', '/suivi-prestation', '/devis-prestation', '/estimation-devis'].some((p) => window.location.pathname.startsWith(p))}>
                                            {isModuleActive('suivi_prestation') && <SidebarItem icon={Briefcase} label="Dossiers clients" to="/suivi-prestation" active={['/suivi-prestation', '/estimation-devis', '/devis-prestation', '/abonnements'].some((p) => window.location.pathname.startsWith(p))} collapsed={isCollapsed} />}
                                            {isModuleActive('prestations') && <SidebarItem icon={Package} label="Prestations" to="/prestations" active={window.location.pathname === '/prestations'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {isModuleActive('commerciaux') && <MenuCommerciaux collapsed={isCollapsed} />}
                                    {isModuleActive('planning_rdv') && (
                                        <SidebarCategory icon={Calendar} label="Planning & agenda" collapsed={isCollapsed} defaultOpen={['/planning-rdv', '/commissions', '/horaires-equipe'].includes(window.location.pathname)} badge={pendingBookingRequestCount}>
                                            <SidebarItem icon={CalendarClock} label="Planning"
                                                to={nextPendingBookingRequest ? `/planning-rdv?focus_date=${nextPendingBookingRequest.date}&focus_id=${nextPendingBookingRequest.id}` : '/planning-rdv'}
                                                active={window.location.pathname === '/planning-rdv'} collapsed={isCollapsed} badge={pendingBookingRequestCount} />
                                            <SidebarItem icon={Clock} label="Horaires de l'équipe" to="/horaires-equipe" active={window.location.pathname === '/horaires-equipe'} collapsed={isCollapsed} />
                                            <SidebarItem icon={Users} label="Commissions & temps" to="/commissions" active={window.location.pathname === '/commissions'} collapsed={isCollapsed} />
                                        </SidebarCategory>
                                    )}
                                    {/* Avec « Dossiers clients », les contrats annuels sont un onglet de ce module ; seul un établissement sans Dossiers garde l'entrée à part. */}
                                    {isModuleActive('contrats_abonnement') && !isModuleActive('suivi_prestation') && (
                                        <SidebarCategory icon={Repeat} label="Contrats annuels" collapsed={isCollapsed} defaultOpen={['/abonnements'].some((p) => window.location.pathname.startsWith(p))}>
                                            <SidebarItem icon={Repeat} label="Contrats annuels" to="/abonnements" active={window.location.pathname === '/abonnements'} collapsed={isCollapsed} />
                                        </SidebarCategory>
                                    )}
                                    {/* Scindé en 3 (2026-09-05, demande d'Emeni : "trop de modules, mal rangé") :
                                        CRM & RDV reste la relation de contact pure (miroir du même découpage côté
                                        Restauration) ; Prestations & devis regroupe le pipeline commercial (catalogue
                                        → devis → suivi du dossier) ; Abonnements reste à part car c'est un flux
                                        récurrent distinct, pas un dossier ponctuel. */}
                                    {(isModuleActive('crm') || isModuleActive('rdv_pro')) && (
                                        <SidebarCategory icon={Building2} label="CRM & RDV" collapsed={isCollapsed} defaultOpen={['/crm', '/rdv-pro'].some((p) => window.location.pathname.startsWith(p))}>
                                            {isModuleActive('crm') && <SidebarItem icon={Users} label="CRM Contacts" to="/crm" active={window.location.pathname === '/crm'} collapsed={isCollapsed} />}
                                            {/* RDV Pro ouvert au Prestataire (2026-09-01) : le rendez-vous simple (devis, visite
                                                technique...) qui ne doit pas se confondre avec une prestation facturée du
                                                Planning. Même écran, même table que côté restauration. */}
                                            {isModuleActive('rdv_pro') && <SidebarItem icon={CalendarCheck} label="RDV Pro" to="/rdv-pro" active={window.location.pathname === '/rdv-pro'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {/* Fournisseurs & Commandes étaient absents ici alors que le super-admin pouvait les activer
                                        (2026-10-28) : le module était « activé » mais invisible pour un client prestation. */}
                                    {(isModuleActive('fournisseurs') || isModuleActive('commandes')) && (
                                        <SidebarCategory icon={Truck} label="Fournisseurs" collapsed={isCollapsed} defaultOpen={['/fournisseurs', '/commandes'].some((p) => window.location.pathname.startsWith(p))}>
                                            {isModuleActive('fournisseurs') && <SidebarItem icon={Truck} label="Fournisseurs" to="/fournisseurs" active={window.location.pathname.startsWith('/fournisseurs')} collapsed={isCollapsed} />}
                                            {isModuleActive('commandes') && <SidebarItem icon={ClipboardList} label="Commandes" to="/commandes" active={window.location.pathname === '/commandes'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {/* Trésorerie n'a pas encore d'écran ici : scaffold uniquement (Paramètres > Trésorerie),
                                        tant que la vraie synchro bancaire n'est pas branchée (voir TresorerieSettings.tsx). */}
                                    {(isModuleActive('facture') || isModuleActive('achats')) && (
                                        <SidebarCategory icon={FileText} label="Facturation" collapsed={isCollapsed} defaultOpen={['/factures', '/achats'].includes(window.location.pathname)}>
                                            {isModuleActive('facture') && <SidebarItem icon={FileText} label="Factures" to="/factures" active={window.location.pathname === '/factures'} collapsed={isCollapsed} />}
                                            {isModuleActive('achats') && <SidebarItem icon={ShoppingBag} label="Achats" to="/achats" active={window.location.pathname === '/achats'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {(isModuleActive('marketing_pub') || isModuleActive('avis') || isModuleActive('ma_carte') || isModuleActive('messagerie_clients')) && (
                                        <SidebarCategory icon={Megaphone} label="Marketing" collapsed={isCollapsed} badge={conseillereAttente} defaultOpen={['/marketing', '/avis', '/ma-carte', '/messagerie-clients'].some((p) => window.location.pathname.startsWith(p))}>
                                            {isModuleActive('marketing_pub') && <SidebarItem icon={Megaphone} label="Pub & Newsletter" to="/marketing" active={window.location.pathname.startsWith('/marketing')} collapsed={isCollapsed} />}
                                            {isModuleActive('avis') && <SidebarItem icon={Star} label="Avis clients" to="/avis" active={window.location.pathname === '/avis'} collapsed={isCollapsed} />}
                                            {isModuleActive('ma_carte') && <SidebarItem icon={QrCode} label="Ma Carte" to="/ma-carte" active={window.location.pathname === '/ma-carte'} collapsed={isCollapsed} />}
                                            {/* "Messagerie clients" et non "Messagerie" : ne pas confondre avec la messagerie interne
                                                salariés (catégorie "RH & équipe", /messagerie). */}
                                            {isModuleActive('messagerie_clients') && <SidebarItem icon={MessageSquare} label="Messagerie clients" to="/messagerie-clients" active={window.location.pathname === '/messagerie-clients'} collapsed={isCollapsed} badge={conseillereAttente} />}
                                        </SidebarCategory>
                                    )}
                                    {isModuleActive('jeux') && (
                                        <SidebarCategory icon={Gamepad2} label="Jeux" collapsed={isCollapsed} defaultOpen={window.location.pathname.startsWith('/jeux')}>
                                            <SidebarItem icon={Gamepad2} label="Salle de pause" to="/jeux" active={window.location.pathname === '/jeux'} collapsed={isCollapsed} />
                                        </SidebarCategory>
                                    )}
                                    {(isModuleActive('todo') || isModuleActive('notes')) && (
                                        <SidebarCategory icon={ListChecks} label="Personnel" collapsed={isCollapsed} defaultOpen={['/todo', '/notes'].includes(window.location.pathname)}>
                                            {isModuleActive('todo') && <SidebarItem icon={ListChecks} label="ToDo" to="/todo" active={window.location.pathname === '/todo'} collapsed={isCollapsed} />}
                                            {isModuleActive('notes') && <SidebarItem icon={NotebookText} label="Notes" to="/notes" active={window.location.pathname === '/notes'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                </>
                            ) : (
                                <>
                                    {(isModuleActive('employes') || isModuleActive('portail_salarie')) && (
                                        <SidebarCategory icon={Users} label="RH & équipe" collapsed={isCollapsed} defaultOpen={['/employes', '/pointage-admin'].includes(window.location.pathname)}>
                                            {isModuleActive('employes') && <SidebarItem icon={Users} label="Postes & Employés" to="/employes" active={window.location.pathname === '/employes'} collapsed={isCollapsed} />}
                                            {isModuleActive('portail_salarie') && <SidebarItem icon={Clock} label="Pointage" to="/pointage-admin" active={window.location.pathname === '/pointage-admin'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {(isModuleActive('demande_conges') || isModuleActive('portail_salarie')) && (
                                        <SidebarCategory icon={MessageSquare} label="Messagerie" collapsed={isCollapsed} defaultOpen={['/messagerie', '/notes-de-frais', '/demandes-conges'].includes(window.location.pathname)} badge={pendingAbsenceCount + teamMessagesUnreadCount + pendingExpenseCount}>
                                            {isModuleActive('portail_salarie') && <SidebarItem icon={MessageSquare} label="Messages" to="/messagerie" active={window.location.pathname === '/messagerie'} collapsed={isCollapsed} badge={teamMessagesUnreadCount} />}
                                            {isModuleActive('portail_salarie') && <SidebarItem icon={Receipt} label="Notes de frais" to="/notes-de-frais" active={window.location.pathname === '/notes-de-frais'} collapsed={isCollapsed} badge={pendingExpenseCount} />}
                                            {isModuleActive('demande_conges') && <SidebarItem icon={Users} label="Demande de congé(s)" to="/demandes-conges" active={window.location.pathname === '/demandes-conges'} collapsed={isCollapsed} badge={pendingAbsenceCount} />}
                                        </SidebarCategory>
                                    )}
                                    {(isModuleActive('planning') || isModuleActive('exception_service') || isModuleActive('livre_reservations')) && (
                                        <SidebarCategory icon={Calendar} label="Planning & agenda" collapsed={isCollapsed} defaultOpen={['/planning', '/exception-service', '/reservations'].includes(window.location.pathname)}>
                                            {isModuleActive('planning') && <SidebarItem icon={Calendar} label="Planning" to="/planning" active={window.location.pathname === '/planning'} collapsed={isCollapsed} />}
                                            {isModuleActive('exception_service') && <SidebarItem icon={UtensilsCrossed} label="Service d'exception" to="/exception-service" active={window.location.pathname === '/exception-service'} collapsed={isCollapsed} />}
                                            {isModuleActive('livre_reservations') && <SidebarItem icon={BookOpen} label="Réservations" to="/reservations" active={window.location.pathname === '/reservations'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {/* « Commercial » regroupe ce qui se vend à un client : la privatisation, les menus que
                                        ses convives choisissent, et la carte qui les alimente. Ces trois écrans étaient
                                        rangés sous « Planning & agenda », où ils n'avaient rien à voir avec un planning
                                        d'équipe. Demande d'Emeni (2026-08-25). */}
                                    {(isModuleActive('evenementiel') || isModuleActive('suivi_privatisation') || isModuleActive('menus_convives')) && (
                                        <SidebarCategory icon={Briefcase} label="Commercial" collapsed={isCollapsed} defaultOpen={['/evenementiel', '/suivi-privatisation', '/menus-convives'].some((path) => window.location.pathname.startsWith(path))}>
                                            {isModuleActive('evenementiel') && <SidebarItem icon={Briefcase} label="Événementiel" to="/evenementiel" active={window.location.pathname.startsWith('/evenementiel')} collapsed={isCollapsed} />}
                                            {isModuleActive('suivi_privatisation') && <SidebarItem icon={Briefcase} label="Suivi privatisation" to="/suivi-privatisation" active={window.location.pathname.startsWith('/suivi-privatisation')} collapsed={isCollapsed} />}
                                            {isModuleActive('menus_convives') && <SidebarItem icon={Utensils} label="Menus & Convives" to="/menus-convives" active={window.location.pathname.startsWith('/menus-convives')} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {/* « Cuisine » sépare ce qui se PRÉPARE de ce qui se VEND. Menu & Plats était rangé
                                        sous Commercial, où il voisinait avec le suivi des affaires alors qu'il s'agit du
                                        catalogue de la cuisine ; le Mode terrain, lui, n'était atteignable que par un lien
                                        depuis un événement, ce qui obligeait un chef à traverser le module commercial un
                                        soir de service. Demande d'Emeni (2026-08-26). */}
                                    {(isModuleActive('mode_terrain') || isModuleActive('menu_plats') || isModuleActive('origine_viandes')) && (
                                        <SidebarCategory icon={ChefHat} label="Cuisine" collapsed={isCollapsed} defaultOpen={['/mode-terrain', '/menu-plats', '/origine-viandes'].some((path) => window.location.pathname.startsWith(path))}>
                                            {isModuleActive('mode_terrain') && <SidebarItem icon={ChefHat} label="Mode terrain" to="/mode-terrain" active={window.location.pathname.startsWith('/mode-terrain')} collapsed={isCollapsed} />}
                                            {isModuleActive('menu_plats') && <SidebarItem icon={Utensils} label="Menu & Plats" to="/menu-plats" active={window.location.pathname.startsWith('/menu-plats')} collapsed={isCollapsed} />}
                                            {isModuleActive('origine_viandes') && <SidebarItem icon={Beef} label="Origine des viandes" to="/origine-viandes" active={window.location.pathname.startsWith('/origine-viandes')} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {(isModuleActive('crm') || isModuleActive('rdv_pro') || isModuleActive('ma_carte') || isModuleActive('messagerie_clients')) && (
                                        <SidebarCategory icon={Building2} label="Relation & opérations client" collapsed={isCollapsed} defaultOpen={['/crm', '/rdv-pro', '/ma-carte', '/messagerie-clients'].includes(window.location.pathname)}>
                                            {isModuleActive('crm') && <SidebarItem icon={Users} label="CRM Contacts" to="/crm" active={window.location.pathname === '/crm'} collapsed={isCollapsed} />}
                                            {isModuleActive('rdv_pro') && <SidebarItem icon={CalendarCheck} label="RDV Pro" to="/rdv-pro" active={window.location.pathname === '/rdv-pro'} collapsed={isCollapsed} />}
                                            {isModuleActive('ma_carte') && <SidebarItem icon={QrCode} label="Ma Carte" to="/ma-carte" active={window.location.pathname === '/ma-carte'} collapsed={isCollapsed} />}
                                            {isModuleActive('messagerie_clients') && <SidebarItem icon={MessageSquare} label="Messagerie clients" to="/messagerie-clients" active={window.location.pathname === '/messagerie-clients'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {(isModuleActive('fournisseurs') || isModuleActive('commandes') || isModuleActive('extras_partenaires') || isModuleActive('extras')) && (
                                        <SidebarCategory icon={Truck} label="Fournisseurs & Partenaires" collapsed={isCollapsed} defaultOpen={['/fournisseurs', '/commandes', '/extras-partenaires', '/extras'].some((p) => window.location.pathname.startsWith(p))}>
                                            {isModuleActive('fournisseurs') && <SidebarItem icon={Truck} label="Fournisseurs" to="/fournisseurs" active={window.location.pathname.startsWith('/fournisseurs')} collapsed={isCollapsed} />}
                                            {isModuleActive('commandes') && <SidebarItem icon={ClipboardList} label="Commandes" to="/commandes" active={window.location.pathname === '/commandes'} collapsed={isCollapsed} />}
                                            {isModuleActive('extras_partenaires') && <SidebarItem icon={HardHat} label="Partenaires Extras" to="/extras-partenaires" active={window.location.pathname.startsWith('/extras-partenaires')} collapsed={isCollapsed} />}
                                            {isModuleActive('extras') && <SidebarItem icon={HardHat} label="Extras" to="/extras" active={window.location.pathname === '/extras'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {/* Trésorerie n'a pas encore d'écran ici : scaffold uniquement (Paramètres > Trésorerie),
                                        tant que la vraie synchro bancaire n'est pas branchée (voir TresorerieSettings.tsx). */}
                                    {(isModuleActive('facture') || isModuleActive('achats')) && (
                                        <SidebarCategory icon={FileText} label="Facturation" collapsed={isCollapsed} defaultOpen={['/factures', '/achats'].includes(window.location.pathname)}>
                                            {isModuleActive('facture') && <SidebarItem icon={FileText} label="Factures" to="/factures" active={window.location.pathname === '/factures'} collapsed={isCollapsed} />}
                                            {isModuleActive('achats') && <SidebarItem icon={ShoppingBag} label="Achats" to="/achats" active={window.location.pathname === '/achats'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                    {isModuleActive('jeux') && (
                                        <SidebarCategory icon={Gamepad2} label="Jeux" collapsed={isCollapsed} defaultOpen={window.location.pathname.startsWith('/jeux')}>
                                            <SidebarItem icon={Gamepad2} label="Salle de pause" to="/jeux" active={window.location.pathname === '/jeux'} collapsed={isCollapsed} />
                                        </SidebarCategory>
                                    )}
                                    {(isModuleActive('todo') || isModuleActive('notes')) && (
                                        <SidebarCategory icon={ListChecks} label="Personnel" collapsed={isCollapsed} defaultOpen={['/todo', '/notes'].includes(window.location.pathname)}>
                                            {isModuleActive('todo') && <SidebarItem icon={ListChecks} label="ToDo" to="/todo" active={window.location.pathname === '/todo'} collapsed={isCollapsed} />}
                                            {isModuleActive('notes') && <SidebarItem icon={NotebookText} label="Notes" to="/notes" active={window.location.pathname === '/notes'} collapsed={isCollapsed} />}
                                        </SidebarCategory>
                                    )}
                                </>
                            )}
                            {(user?.type as string) !== 'employe' && isModuleActive('support') && (
                                <>
                                    {!isCollapsed && <div className="mt-3 mb-1 px-3 text-[9px] font-bold text-slate-600 dark:text-content-muted uppercase tracking-widest">Support</div>}
                                    <button
                                        onClick={() => setShowSupportModal(true)}
                                        className={`w-full group flex items-center ${isCollapsed ? 'justify-center' : 'gap-2'} ${isCollapsed ? 'px-0 py-1.5' : 'px-3 py-2'} rounded-lg transition-all text-[var(--text-secondary)] hover:bg-[var(--interactive-hover)] hover:text-[var(--text-primary)] relative`}
                                        title={isCollapsed ? 'Support' : undefined}
                                    >
                                        <span className={`inline-flex items-center justify-center ${isCollapsed ? 'w-8 h-8 rounded-lg group-hover:bg-[var(--interactive-hover)]' : 'w-5 h-5'} transition-all relative`}>
                                            <MessageSquare className="w-[18px] h-[18px] shrink-0" />
                                            {clientSupportUnreadCount > 0 && (
                                                <span className="absolute -top-1 -right-1 min-w-5 h-5 px-1 rounded-full bg-red-500 text-content text-[10px] font-bold flex items-center justify-center">
                                                    {clientSupportUnreadCount > 99 ? '99+' : clientSupportUnreadCount}
                                                </span>
                                            )}
                                        </span>
                                        {!isCollapsed && <span className="font-medium text-[15px] min-w-0 truncate">Support client</span>}
                                    </button>
                                </>
                            )}
                        </>
                    )}
                    {user?.type === 'client' && (
                        <SidebarItem icon={CreditCard} label="Mon abonnement" to="/mon-abonnement" active={window.location.pathname === '/mon-abonnement'} collapsed={isCollapsed} />
                    )}
                    {user?.type === 'collaborator' && !commercialSeul && (
                        <SidebarItem icon={KeyRound} label="Demander un accès" to="/demande-acces" active={window.location.pathname === '/demande-acces'} collapsed={isCollapsed} />
                    )}
                    {user?.type === 'client' && isModuleActive('organisation') && (
                        <SidebarCategory icon={Building2} label="Organisation" collapsed={isCollapsed} badge={demandesEnAttente} defaultOpen={['/organisation', '/mes-modules', '/droits-usage', '/equipe'].some((p) => window.location.pathname.startsWith(p))}>
                            <SidebarItem icon={Package} label="Mes modules" to="/mes-modules" active={window.location.pathname === '/mes-modules'} collapsed={isCollapsed} />
                            <SidebarItem icon={Building2} label="Mon établissement" to="/organisation" active={window.location.pathname.startsWith('/organisation')} collapsed={isCollapsed} />
                            <SidebarItem icon={UserCog} label="Mon équipe" to="/equipe" active={window.location.pathname.startsWith('/equipe')} collapsed={isCollapsed} badge={demandesEnAttente} />
                        </SidebarCategory>
                    )}
                </nav>

                <div className="mt-auto pt-3 border-t border-[var(--border-color)]">
                    {/* Centre de notifications (2026-09-21, ouvert aux salariés le 2026-09-25) : demandes de
                        devis, rendez-vous et documents signés reçus côté établissement ; côté salarié,
                        seulement ses propres assignations (le serveur filtre, jamais les notifications de
                        gestion de son employeur). Posé juste au-dessus du compte, là où l'œil revient. */}
                    {!commercialSeul && <div className="mb-1"><CentreNotifications compact={isCollapsed} /></div>}
                    <button
                        onClick={toggleTheme}
                        className={`w-full flex items-center ${isCollapsed ? 'justify-center' : 'gap-2'} px-3 py-2 text-[var(--text-secondary)] hover:bg-[var(--interactive-hover)] hover:text-[var(--text-primary)] rounded-lg transition-all font-medium mb-2`}
                        title={isCollapsed ? (theme === 'dark' ? 'Passer en clair' : 'Passer en sombre') : undefined}
                    >
                        {theme === 'dark' ? <Sun size={17} /> : <Moon size={17} />}
                        {!isCollapsed && <span className="text-[14px]">{theme === 'dark' ? 'Mode clair' : 'Mode sombre'}</span>}
                    </button>

                    <div className={`flex items-center ${isCollapsed ? 'justify-center' : 'gap-2'} px-2 mb-3`}>
                        <div className="w-8 h-8 rounded-full flex items-center justify-center font-bold text-[var(--text-primary)] border border-[var(--border-color)] bg-[var(--bg-soft)]">
                            {user?.name ? user.name[0].toUpperCase() : '?'}
                        </div>
                        {!isCollapsed && (
                            <div className="flex-1 min-w-0">
                                <p className="text-[15px] font-bold truncate text-[var(--text-primary)]">{user?.name}</p>
                                <p className="text-[11px] text-[var(--text-muted)] truncate capitalize">{user?.type}</p>
                            </div>
                        )}
                    </div>
                    <button
                        onClick={() => navigate((user?.type === 'admin' || user?.role === 'superadmin') ? '/admin/settings' : '/parametres')}
                        className={`w-full flex items-center ${isCollapsed ? 'justify-center' : 'gap-2'} px-3 py-2 text-[var(--text-secondary)] hover:bg-[var(--interactive-hover)] rounded-lg transition-all font-medium mb-1`}
                        title={isCollapsed ? 'Paramètres' : undefined}
                    >
                        <Settings size={17} />
                        {!isCollapsed && <span className="text-[14px]">Paramètres</span>}
                    </button>
                    <button
                        onClick={handleLogout}
                        className={`w-full flex items-center ${isCollapsed ? 'justify-center' : 'gap-2'} px-3 py-2 text-red-400 hover:bg-red-500/10 rounded-lg transition-all font-medium`}
                        title={isCollapsed ? 'Déconnexion' : undefined}
                    >
                        <LogOut size={17} />
                        {!isCollapsed && <span className="text-[14px]">Déconnexion</span>}
                    </button>
                </div>
            </motion.aside>

            {/* Main Content */}
            <main className="flex-1 min-w-0 flex flex-col h-screen overflow-hidden transition-colors duration-200">
                {/* Mobile Header */}
                <div className="md:hidden flex items-center justify-between p-4 border-b border-[var(--border-color)] bg-[var(--bg-sidebar)] z-30 flex-shrink-0">
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center overflow-hidden">
                            {resolvedLogoUrl ? (
                                <img src={resolvedLogoUrl} alt="Logo" className="w-full h-full object-cover" />
                            ) : (
                                <ShieldCheck className="text-content" size={20} />
                            )}
                        </div>
                        <span className="font-bold text-xl truncate">{user?.company_name || "L'IAmani"}</span>
                    </div>
                    <div className="flex items-center gap-1">
                    {!commercialSeul && <CentreNotifications compact />}
                    <button onClick={() => setIsMobileMenuOpen(true)} className="p-2 -mr-2 text-[var(--text-primary)]">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/></svg>
                    </button>
                    </div>
                </div>
                
                <div className="flex-1 overflow-auto p-4 md:p-10">
                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        {/* Une chose à faire, pas une notification : un salarié encore sur le mot de passe
                            fabriqué par l'application doit le voir sur chacun de ses écrans. */}
                        <MotDePasseProvisoireBanner />
                        {hors ? <Navigate to="/" replace /> : children}
                    </motion.div>
                </div>
                {user?.type !== 'admin' && isModuleActive('support') && (
                    <SupportModal 
                        open={showSupportModal} 
                        onClose={() => {
                            setShowSupportModal(false);
                            refreshClientUnreadCount();
                        }} 
                        canOpen 
                        onUnreadCountChanged={refreshClientUnreadCount}
                    />
                )}
            </main>
            {isModuleActive('todo') && <FloatingTodoWidget />}
            {/* L'aide guidée : l'ampoule et sa fenêtre. Elle décide elle-même si elle a quelque chose
                à dire, et ne s'affiche que pour un compte client ou collaborateur. */}
            <AideGuidee />
        </div>
    );
}

// --- Views ---

const DigitalClock = () => {
    const [time, setTime] = React.useState(new Date());

    React.useEffect(() => {
        const timer = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    const hours = String(time.getHours()).padStart(2, '0');
    const minutes = String(time.getMinutes()).padStart(2, '0');
    const seconds = String(time.getSeconds()).padStart(2, '0');

    return (
        <div className="flex flex-col items-center justify-center h-full">
            <div className="text-[var(--text-muted)] text-[9px] font-bold uppercase tracking-widest mb-1">Heure actuelle</div>
            <div className="flex items-center gap-2 text-3xl md:text-4xl font-black tracking-tighter text-[var(--text-primary)] font-mono">
                <span>{hours}</span>
                <span className="animate-pulse text-brand-500">:</span>
                <span>{minutes}</span>
                <span className="animate-pulse text-brand-500 text-xl md:text-2xl">:</span>
                <span className="text-xl md:text-2xl text-[var(--text-muted)] w-[1.2ch]">{seconds}</span>
            </div>
            <div className="text-[var(--text-muted)] text-[10px] mt-1 font-medium capitalize">
                {time.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })}
            </div>
        </div>
    );
};

const DashboardView = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [stats, setStats] = React.useState<any[]>([]);
    const [recentActivity, setRecentActivity] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [showSendDocModal, setShowSendDocModal] = React.useState(false);
    // "Demandes récurrentes" (historique des Démarches client envoyées) : déplacé des Réglages vers une
    // tuile dédiée sur le Dashboard, à la demande du propriétaire — ce n'était pas à sa place dans les
    // Réglages généraux. Visible dès que le module CRM est actif (mêmes conditions qu'avant) — sauf pour
    // Prestation, qui y accède désormais directement depuis le Planning ("Paiement RDV"), sur demande du
    // propriétaire de ne plus la dupliquer sur le Dashboard pour ce type de client.
    const [canSeeDemandes, setCanSeeDemandes] = React.useState(false);

    React.useEffect(() => {
        if (user) {
            loadStats();
        }
        if (user?.type === 'client') {
            authApi.getMyModules().then((modules: any) => {
                const names = (Array.isArray(modules) ? modules : []).filter((m: any) => m.is_active === 1).map((m: any) => m.module_name);
                setCanSeeDemandes(names.includes('crm') && (user as any)?.client_type !== 'prestation');
            }).catch(() => setCanSeeDemandes(false));
        }
    }, [user]);

    const loadStats = async () => {
        try {
            if (user?.type === 'admin') {
                const data = await adminApi.getStats();
                setStats([
                    { label: 'Clients Actifs', value: data.clientsCount.toString(), icon: Users },
                    { label: 'Revenus Mensuels', value: data.revenue, icon: FileText },
                    { label: 'Modules Activés', value: data.activeModulesCount.toString(), icon: Settings },
                    { label: 'Collaborateurs', value: data.collaboratorsCount.toString(), icon: ShieldCheck },
                ]);
                setRecentActivity([]);
            } else {
                const data = await dashboardApi.getClientStats();
                if (user?.client_type === 'prestation') {
                    setStats([
                        { label: 'Employés', value: String(data?.employes ?? 0), icon: Users },
                        { label: 'Rendez-vous', value: String(data?.appointments ?? 0), icon: CalendarClock },
                        { label: 'Factures', value: String(data?.factures ?? 0), icon: FileText },
                        { label: 'Prestations', value: String(data?.prestationsCatalogCount ?? 0), icon: Package },
                    ]);
                } else {
                    setStats([
                        { label: 'Employés', value: String(data?.employes ?? 0), icon: Users },
                        { label: 'Événements', value: String(data?.evenements ?? 0), icon: Calendar },
                        { label: 'Factures', value: String(data?.factures ?? 0), icon: FileText },
                        { label: 'Planning', value: String(data?.planning ?? 0), icon: Briefcase },
                    ]);
                }
                setRecentActivity(Array.isArray(data?.recentActivity) ? data.recentActivity : []);
            }
        } catch (e) {
            console.error(e);
            setRecentActivity([]);
        } finally {
            setLoading(false);
        }
    };

    const formatRelativeTime = (value?: string) => {
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '';
        const diffMs = Date.now() - date.getTime();
        const diffMin = Math.max(1, Math.floor(diffMs / 60000));
        if (diffMin < 60) return `Il y a ${diffMin} min`;
        const diffHours = Math.floor(diffMin / 60);
        if (diffHours < 24) return `Il y a ${diffHours} h`;
        const diffDays = Math.floor(diffHours / 24);
        if (diffDays < 30) return `Il y a ${diffDays} j`;
        return date.toLocaleDateString();
    };

    const formatActivityDetail = (value?: string) => {
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
    };

    const getActivityPresentation = (type?: string) => {
        switch (type) {
            case 'facture':
                return { icon: FileText, color: 'text-emerald-500' };
            case 'evenement':
                return { icon: Calendar, color: 'text-brand-500' };
            case 'employe':
                return { icon: Users, color: 'text-sky-500' };
            case 'planning':
                return { icon: Briefcase, color: 'text-warning-500' };
            default:
                return { icon: ChevronRight, color: 'text-[var(--text-muted)]' };
        }
    };

    // Habillage repris des lots 4, 5 et 6 (décision d'Emeni du 16/09 : l'habillage seulement).
    // Mêmes chiffres, mêmes blocs, mêmes raccourcis, aux mêmes conditions — seul le vêtement change.
    // Les briques sont dans components/Dashboard/DashboardUi.tsx, App.tsx étant déjà bien au-delà de
    // la limite de 500 lignes du projet.
    const estAdmin = user?.type === 'admin';
    // Le nouvel écran (lot 14) n'existe que pour la Restauration : il parle de services, de couverts et de
    // privatisations, ce qui n'a pas de sens pour un prestataire.
    const estRestauration = !estAdmin && familleCompte((user as any)?.client_type) === 'restauration';
    return (
        <div className="space-y-5">
            <DashboardHeader
                societe={estAdmin ? '' : ((user as any)?.company_name || user?.name || '')}
                titre="Tableau de bord"
                sousTitre={estAdmin
                    ? "Vue d'ensemble de la plateforme L'IAmani."
                    : `Bienvenue sur votre espace de gestion, ${user?.name}.`}
                actions={user?.type === 'client' ? (
                    <button type="button" onClick={() => navigate('/equipe')} className={PILL}>
                        <UserPlus size={14} /> Équipe et comptes
                    </button>
                ) : undefined}
            />

            {/* Restauration : l'écran du lot 14 remplace les quatre compteurs, l'horloge et le pavé de
                support — il répond aux mêmes questions en disant ce qui attend une décision, plutôt qu'en
                affichant des totaux qui ne se lisent pas. Les autres types de client gardent l'écran
                d'origine, qui n'a pas encore sa maquette. */}
            {estRestauration ? (
                <RestaurationDashboard />
            ) : (
                <DashboardStats chiffres={stats} chargement={loading} />
            )}

            {canSeeDemandes && familleCompte(user?.client_type) === 'restauration' && (
                <DashboardShortcut
                    icon={Send}
                    titre="Envoyer une démarche"
                    description="Par email, à un contact déjà en CRM ou non — un contact sera créé automatiquement s'il n'existe pas encore"
                    onClick={() => setShowSendDocModal(true)}
                />
            )}

            {canSeeDemandes && (
                <DashboardShortcut
                    icon={ClipboardList}
                    titre="Demandes récurrentes"
                    description="Historique des Démarches client envoyées à vos contacts"
                    onClick={() => navigate('/demandes-recurrentes')}
                    mèneAilleurs
                />
            )}

            {showSendDocModal && (
                <SendDocumentByEmailModal onClose={() => setShowSendDocModal(false)} onSent={() => setShowSendDocModal(false)} />
            )}

            {/* Masqué en Restauration : l'horloge et le pavé de support font doublon avec le nouvel écran,
                qui porte déjà son bloc « Support L'IAmani ». Non rendu du tout plutôt que caché en CSS —
                l'horloge se réveille chaque seconde, même invisible. */}
            {!estRestauration && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                <DashboardSection className="lg:col-span-2 flex flex-col items-center justify-center min-h-[150px]">
                    <DigitalClock />
                </DashboardSection>

                <DashboardSection titre={estAdmin ? 'Maintenance système' : "Support L'IAmani"}>
                    <p className="text-[12.5px] text-content-muted leading-relaxed">
                        {estAdmin
                            ? "Vérifiez l'état des serveurs et les logs de sécurité de la plateforme."
                            : "Une question sur le fonctionnement, une demande de modification ou mise à jour, une demande d'ajout d'un système de gestion, ou tout ce qui pourrait vous faciliter votre travail ? Contactez le support client."}
                    </p>
                    {estAdmin || user?.role === 'superadmin' ? (
                        <button type="button" className={`${PILL} mt-4`}>Voir les logs</button>
                    ) : (
                        <p className="text-[11.5px] text-content-muted mt-4">Le support est disponible dans la barre latérale.</p>
                    )}
                </DashboardSection>
            </div>
            )}

            {!estAdmin && <PlanningTableView />}
        </div>
    );
};

const SupportAdminView = () => {
    const [status, setStatus] = React.useState<'OPEN' | 'CLOSED'>('OPEN');
    const [tickets, setTickets] = React.useState<any[]>([]);
    const [selected, setSelected] = React.useState<any | null>(null);
    const confirmAction = useConfirm();
    const [messages, setMessages] = React.useState<any[]>([]);
    const [text, setText] = React.useState('');
    const [file, setFile] = React.useState<File | null>(null);
    const [loading, setLoading] = React.useState(true);
    const [sending, setSending] = React.useState(false);

    const loadTickets = React.useCallback(async () => {
        setLoading(true);
        try {
            const data = await supportApi.getAdminTickets(status);
            setTickets(data || []);
            if (data?.length && !selected) {
                setSelected(data[0]);
            }
            if (!data?.length) {
                setSelected(null);
                setMessages([]);
            }
        } finally {
            setLoading(false);
        }
    }, [status, selected]);

    const loadMessages = React.useCallback(async (ticketId: string) => {
        const data = await supportApi.getAdminTicketMessages(ticketId);
        setMessages(Array.isArray(data) ? data : (data?.messages || []));
    }, []);

    React.useEffect(() => { loadTickets(); }, [loadTickets]);
    React.useEffect(() => {
        if (selected?.id) loadMessages(selected.id);
    }, [selected?.id, loadMessages]);

    const send = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!selected?.id || (!text.trim() && !file)) return;
        try {
            setSending(true);
            let fileUrl: string | null = null;
            let fileName: string | null = null;
            if (file) {
                const fd = new FormData();
                fd.append('file', file);
                const up = await supportApi.uploadFile(fd);
                fileUrl = up.file_url;
                fileName = up.file_name || file.name;
            }
            await supportApi.sendAdminMessage(selected.id, { message: text.trim() || null, file_url: fileUrl, file_name: fileName });
            setText('');
            setFile(null);
            await loadMessages(selected.id);
            await loadTickets();
        } finally {
            setSending(false);
        }
    };

    const closeTicket = async () => {
        if (!selected?.id) return;
        await supportApi.closeTicket(selected.id);
        setSelected(null);
        setMessages([]);
        await loadTickets();
    };

    const deleteTicket = async () => {
        if (!selected?.id) return;
        if (!(await confirmAction({ title: 'Supprimer le ticket ?', description: <>Le ticket « {selected?.subject || selected?.title || 'sans objet'} » et tous ses messages seront effacés.</>, confirmLabel: 'Supprimer le ticket' }))) return;
        try {
            await supportApi.deleteTicket(selected.id);
            setSelected(null);
            setMessages([]);
            await loadTickets();
        } catch (e) {
            alert('Erreur lors de la suppression');
        }
    };

    const isImage = (url?: string) => {
        const u = (url || '').toLowerCase();
        return u.endsWith('.png') || u.endsWith('.jpg') || u.endsWith('.jpeg') || u.endsWith('.gif') || u.endsWith('.webp') || u.endsWith('.svg');
    };
    const resolveUrl = (url: string) => (url.startsWith('http') ? url : `${window.location.origin}${url}`);

    return (
        <div className="space-y-6">
            <header className="flex items-center justify-between">
                <div>
                    <h1 className="text-3xl font-bold tracking-tight text-content">Support Client</h1>
                    <p className="text-content-muted mt-1">Tickets ouverts et archivés.</p>
                </div>
                <div className="flex items-center gap-2">
                <EmailsDuModule groupe="support" />
                <div className="flex gap-2 bg-surface p-1 rounded-xl border border-border">
                    <button onClick={() => setStatus('OPEN')} className={`px-4 py-2 rounded-lg text-sm font-semibold ${status === 'OPEN' ? 'bg-white text-slate-900' : 'text-content-muted'}`}>Ouverts</button>
                    <button onClick={() => setStatus('CLOSED')} className={`px-4 py-2 rounded-lg text-sm font-semibold ${status === 'CLOSED' ? 'bg-white text-slate-900' : 'text-content-muted'}`}>Clôturés</button>
                </div>
                </div>
            </header>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="bg-surface border border-border rounded-2xl p-4 lg:col-span-1">
                    {loading ? <p className="text-content-muted">Chargement...</p> : (
                        <div className="space-y-2 max-h-[70vh] overflow-auto">
                            {tickets.length === 0 && <p className="text-content-muted text-sm p-3">Aucun ticket.</p>}
                            {tickets.map((t) => (
                                <button
                                    key={t.id}
                                    onClick={() => setSelected(t)}
                                    className={`w-full text-left p-4 rounded-xl border transition-all ${selected?.id === t.id ? 'border-white/40 bg-surface-soft ring-1 ring-white/10' : 'border-border hover:border-white/20'}`}
                                >
                                    <div className="flex justify-between items-start mb-1">
                                        <p className="text-content font-bold truncate flex-1">{t.company_name}</p>
                                        {t.unread_count > 0 && (
                                            <span className="bg-red-500 text-content text-[10px] px-1.5 py-0.5 rounded-full ml-2 animate-pulse">{t.unread_count}</span>
                                        )}
                                    </div>
                                    <p className="text-[10px] text-content-muted uppercase font-bold tracking-tight mb-1">{t.creator_name || 'Client'}</p>
                                    <p className="text-[10px] text-gray-600">{new Date(t.created_at).toLocaleDateString()}</p>
                                </button>
                            ))}
                        </div>
                    )}
                </div>

                <div className="bg-[var(--bg-app)] border border-border rounded-2xl lg:col-span-2 flex flex-col h-[70vh] overflow-hidden">
                    {!selected ? (
                        <div className="flex-1 flex items-center justify-center text-content-muted">Sélectionnez un ticket</div>
                    ) : (
                        <>
                            <div className="px-4 py-3 border-b border-border bg-surface flex items-center justify-between">
                                <div>
                                    <p className="text-content font-bold">{selected.company_name || selected.client_name}</p>
                                    <p className="text-xs text-content-muted">Ticket: {selected.id}</p>
                                </div>
                                <div className="flex gap-2">
                                    {selected.status === 'OPEN' && (
                                        <button onClick={closeTicket} className="px-3 py-2 text-sm rounded-lg bg-red-500/10 text-red-400 hover:bg-red-500/20">Clôturer l'incident</button>
                                    )}
                                    {selected.status === 'CLOSED' && (
                                        <button onClick={deleteTicket} className="px-3 py-2 text-sm rounded-lg bg-red-600/10 text-red-500 hover:bg-red-600/20">Supprimer</button>
                                    )}
                                </div>
                            </div>

                            <div className="flex-1 overflow-y-auto p-4 space-y-3">
                                {messages.map((m) => (
                                    <div key={m.id} className={`flex ${m.sender_type === 'admin' ? 'justify-end' : 'justify-start'}`}>
                                        <div className={`max-w-[78%] rounded-2xl px-4 py-3 border ${m.sender_type === 'admin' ? 'bg-surface border-[#C8AA6E]/50 text-content' : 'bg-surface-soft border-border text-content'}`}>
                                            {m.message && <p className="text-sm whitespace-pre-wrap">{m.message}</p>}
                                            {m.file_url && (
                                                <a href={resolveUrl(m.file_url)} target="_blank" rel="noreferrer" className="block mt-2 rounded-lg border border-border p-2 hover:bg-surface-soft">
                                                    {isImage(m.file_url) ? (
                                                        <img src={resolveUrl(m.file_url)} className="max-h-40 rounded-md object-contain" />
                                                    ) : (
                                                        <p className="text-sm text-content-muted">{m.file_name || 'Pièce jointe'}</p>
                                                    )}
                                                </a>
                                            )}
                                            <p className="mt-1 text-[10px] text-content-muted">{new Date(m.created_at).toLocaleString()}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {selected.status === 'OPEN' && (
                                <form onSubmit={send} className="p-4 border-t border-border bg-surface">
                                    <div className="flex items-end gap-2">
                                        <label className="p-2 rounded-lg border border-border text-content-muted hover:bg-surface-soft cursor-pointer">
                                            <input type="file" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} />
                                            <Paperclip size={16} />
                                        </label>
                                        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} className="flex-1 resize-none px-3 py-2 rounded-lg bg-surface border border-border text-content outline-none focus:border-border" placeholder="Répondre au client..." />
                                        <button disabled={sending || (!text.trim() && !file)} className="px-4 py-2 rounded-lg bg-white text-slate-900 font-bold disabled:opacity-50">Envoyer</button>
                                    </div>
                                    {file && <p className="text-xs text-content-muted mt-2">Pièce jointe: {file.name}</p>}
                                </form>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

// Les deux ecrans du super admin (la liste des clients et la fiche client) vivaient ici, soit 2 400
// lignes sur les 4 076 de ce fichier. Sortis le 2026-09-20 dans components/Admin/clients/ : App.tsx
// redevient lisible, et chaque ecran tient dans son propre fichier.
const MotDePasseOublie = lazy(() => import('./components/Auth/MotDePasseOublie').then(m => ({ default: m.MotDePasseOublie })));
const NouveauMotDePasse = lazy(() => import('./components/Public/NouveauMotDePasse').then(m => ({ default: m.NouveauMotDePasse })));
const JeuxModule = lazy(() => import('./components/Jeux/JeuxModule').then(m => ({ default: m.JeuxModule })));
const AdminClientsView = lazy(() => import('./components/Admin/clients/AdminClientsView').then(m => ({ default: m.AdminClientsView })));
const AdminClientDetailView = lazy(() => import('./components/Admin/clients/AdminClientDetailView').then(m => ({ default: m.AdminClientDetailView })));

// Page d'accueil publique (déconnecté) ou tableau de bord (connecté) sur la même route "/" — condition
// nécessaire pour que l-iamani.com serve à la fois l'accueil marketing et l'espace connecté sous un seul
// domaine. Placée en dehors du "/*" + <Layout> habituel : la page d'accueil a son propre habillage complet
// (header/footer marketing), pas la sidebar/chrome de l'application.
// Page d'accueil d'un établissement SANS Dashboard (module désactivé depuis le provisioning, 2026-10-09) : la
// première page de ses modules actifs, dans l'ordre où la barre latérale les présente.
const PAGES_ACCUEIL_PAR_MODULE: [string, string][] = [
    ['planning', '/planning'], ['planning_rdv', '/planning-rdv'], ['evenementiel', '/evenementiel'],
    ['suivi_privatisation', '/suivi-privatisation'], ['menus_convives', '/menus-convives'], ['exception_service', '/exception-service'],
    ['prestations', '/prestations'], ['suivi_prestation', '/suivi-prestation'], ['contrats_abonnement', '/abonnements'],
    ['commandes_recues', '/commandes-recues'], ['catalogue_fournisseur', '/mon-catalogue'], ['prix_clients', '/mes-clients'], ['crm', '/crm'], ['rdv_pro', '/rdv-pro'], ['facture', '/factures'], ['fournisseurs', '/fournisseurs'], ['achats', '/achats'], ['employes', '/employes'],
    ['marketing_pub', '/marketing'], ['avis', '/avis'], ['ma_carte', '/ma-carte'], ['messagerie_clients', '/messagerie-clients'],
    ['todo', '/todo'], ['notes', '/notes'], ['jeux', '/jeux'],
];

// Établissement dont TOUS les modules sont désactivés (espace retiré du service) : l'espace est indisponible, sans en donner la cause.
const AucunModule = () => (
    <div className="max-w-xl mx-auto mt-16 p-6 rounded-2xl border border-border bg-surface text-center">
        <h2 className="text-lg font-bold text-content">Service momentanément indisponible</h2>
        <p className="mt-2 text-sm text-content-muted">
            La plateforme est momentanément indisponible. Veuillez réessayer ultérieurement.
        </p>
    </div>
);

const RootRoute = () => {
    const { user, loading } = useAuth();
    // undefined = modules pas encore connus · null = on affiche le Dashboard · chaîne = page vers laquelle partir
    const [accueil, setAccueil] = React.useState<string | null | undefined>(undefined);
    React.useEffect(() => {
        if (!user || user.type === 'admin' || user.type === 'employe') { setAccueil(null); return; }
        let vivant = true;
        authApi.getMyModules().then(async (liste: any) => {
            if (!vivant) return;
            const actifs: string[] = (Array.isArray(liste) ? liste : [])
                .filter((m: any) => m && Number(m.is_active) === 1)
                .map((m: any) => String(m.module_name));
            // Des lignes mais aucune active : tous les modules sont désactivés.
            if (Array.isArray(liste) && liste.length > 0 && actifs.length === 0) { setAccueil('__aucun__'); return; }
            // Compte commercial : son propre accueil, jamais la première page d'un module au hasard.
            if (user.type === 'collaborator' && actifs.includes('commerciaux')) {
                try { const moi = await chargerMoiCommerciaux(); if (moi.role === 'commercial') { setAccueil(null); return; } } catch { /* pas un commercial */ }
            }
            // Aucune liste (compte ancien jamais configuré) ou Dashboard actif : comportement habituel.
            if (actifs.length === 0 || actifs.includes('dashboard')) { setAccueil(null); return; }
            const cible = PAGES_ACCUEIL_PAR_MODULE.find(([nom]) => actifs.includes(nom));
            setAccueil(cible ? cible[1] : null);
        }).catch(() => { if (vivant) setAccueil(null); });
        return () => { vivant = false; };
    }, [user]);
    if (loading) return null;
    if (!user) return <PublicHomepage />;
    if (accueil === undefined) return null;
    if (accueil === '__aucun__') return <Layout><AucunModule /></Layout>;
    if (accueil) return <Navigate to={accueil} replace />;
    return <Layout><AccueilSelonRole /></Layout>;
};

// Tableau de bord de l'établissement, ou accueil du commercial (module Commerciaux) : un commercial ne voit jamais celui de l'établissement.
const AccueilSelonRole = () => {
    const { user } = useAuth();
    const { moi, erreur } = useMoiCommerciaux(user?.type === 'collaborator');
    if (user?.type === 'collaborator' && !moi && !erreur) return null;
    return moi?.role === 'commercial' ? <AccueilCommercial /> : <DashboardView />;
};

// Le favicon de l'onglet du navigateur était figé sur /favicon.png (fichier statique dans index.html),
// jamais relié au logo configuré par le super admin dans Paramètres (loginLogo, déjà utilisé pour le
// logo affiché sur la page de connexion et l'accueil) — corrigé en le mettant à jour dynamiquement au
// chargement de l'app, quelle que soit la page d'entrée (connexion, accueil, tableau de bord...).
const DynamicFavicon = () => {
    React.useEffect(() => {
        adminApi.getGlobalSettings().then((data: any) => {
            if (!data?.loginLogo) return;
            const img = new Image();
            img.onload = () => {
                // Le logo configuré est un rectangle large (logo texte), pas un carré — utilisé tel quel,
                // le navigateur l'écrase dans la case carrée du favicon et le déforme. On le redessine donc
                // "contain" (proportions conservées, centré) sur un canevas carré avant de s'en servir.
                const size = 64;
                const canvas = document.createElement('canvas');
                canvas.width = size;
                canvas.height = size;
                const ctx = canvas.getContext('2d');
                if (!ctx) return;
                const scale = Math.min(size / img.width, size / img.height);
                const w = img.width * scale;
                const h = img.height * scale;
                ctx.drawImage(img, (size - w) / 2, (size - h) / 2, w, h);

                let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.head.appendChild(link);
                }
                link.href = canvas.toDataURL('image/png');
            };
            img.src = data.loginLogo;
        }).catch(() => {});
    }, []);
    return null;
};

const App = () => (
    <Router>
        <AuthProvider>
        <AmbianceProvider>
        <UndoProvider>
        <ConfirmProvider>
        <OrganisationProvider>
            <DynamicFavicon />
            {/* Numero de page, uniquement hors production — voir src/lib/pageRegistry.ts */}
            <PageNumberBadge />
            <Routes>
                <Route path="/" element={<RootRoute />} />
                <Route path="/login" element={<LoginPage />} />
                {/* Publique : le lien de reinitialisation ne suppose aucune session ouverte. */}
                <Route path="/nouveau-mot-de-passe/:token" element={<NouveauMotDePasse />} />
                {/* « Mot de passe oublié » : la personne demande elle-même son lien (2026-10-13). */}
                <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
                <Route path="/reinitialiser-mot-de-passe/:token" element={<NouveauMotDePasse mode="oubli" />} />
                <Route path="/inscription/:token" element={<ClientRegistrationForm />} />
                <Route path="/invitation/:token" element={<InvitationPublique />} />
                <Route path="/nouveau-mot-de-passe-compte/:token" element={<InvitationPublique />} />
                <Route path="/reserver/:clientId" element={<BookingWidget />} />
                <Route path="/rdv-pro-reserver/:clientId" element={<RdvProBookingWidget />} />
                {/* Lien personnel du client du restaurant : sa réservation, annuler, annoncer un retard. */}
                <Route path="/reservation/:token" element={<MaReservationPage />} />
                {/* Réservation de table en ligne (L05-B, étape 2 de docs/zenchef/03-ECARTS-IAMANI.md) : page publique de l'établissement. */}
                <Route path="/reserver-une-table/:etab" element={<Suspense fallback={null}><ReserverTablePage /></Suspense>} />
                {/* Demande de devis ouverte par le simulateur du site (2026-09-20) : photos puis
                    coordonnées, puis un dossier « Demande reçue » dans le Suivi de prestation. */}
                <Route path="/demande-devis/:clientId" element={<DemandeDevisPage />} />
                {/* Ma Carte : page de liens publique (docs/CHANTIER-MA-CARTE.md). */}
                <Route path="/c/:slug" element={<Suspense fallback={null}><CartePublicPage /></Suspense>} />
                <Route path="/c/q/:code" element={<Suspense fallback={null}><CarteRedirect kind="q" /></Suspense>} />
                <Route path="/c/l/:code" element={<Suspense fallback={null}><CarteRedirect kind="l" /></Suspense>} />
                <Route path="/pointage-kiosque/:clientId" element={<PointageKiosque />} />
                <Route path="/documentation/:token" element={<DocumentationResponse />} />
                {/* Lien public d'une Démarche (le même pour tout le monde), cf. DemarchePubliquePage. */}
                <Route path="/d/:token" element={<Suspense fallback={null}><DemarchePubliquePage /></Suspense>} />
                <Route path="/simulateur/:clientId" element={<Suspense fallback={null}><SimulateurPublicPage /></Suspense>} />
                <Route path="/mon-repas/:token" element={<EvenementielGuestPage />} />
                <Route path="/organisateur/:token" element={<OrganisateurPage />} />
                <Route path="/ma-table/:publicToken/:tableNumber" element={<TableCheckinPage />} />
                <Route path="/commande-fournisseur/:token" element={<SupplierOrderConfirmPage />} />
                <Route path="/bon-commande/:token" element={<Suspense fallback={null}><BonCommandePublicPage /></Suspense>} />
                <Route path="/annulation-rdv/:token" element={<RdvCancellationPage />} />
                <Route path="/annulation-prestation/:token" element={<RdvCancellationPage source="prestation" />} />
                <Route path="/desabonnement-marketing/:token" element={<MarketingUnsubscribePage />} />
                <Route path="/mon-avis/:token" element={<AvisPage />} />
                <Route path="/extras-demande/:token" element={<ExtrasRequestConfirmPage />} />
                <Route path="/devis/:token" element={<DevisSignaturePage />} />
                <Route path="/prestation-devis/:token" element={<PrestationDevisSignaturePage />} />
                <Route path="/prestation-reservation/:token" element={<PrestationReservationPage />} />
                <Route path="/espace-client/:token" element={<EspaceClientPage />} />
                <Route path="/mandat-prelevement/:token" element={<MandatPrelevementPage />} />
                <Route path="/contrat/:token" element={<ContractSignaturePage />} />
                <Route element={<LegalLayout />}>
                    <Route path="/legal" element={<LegalMentions />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsOfUse />} />
                </Route>
                {/* Adresse courte de Ma Carte : l-iamani.com/<nom> (src/lib/carteUrls.ts). Uniquement sur ce
                    domaine et jamais pour un segment qui est une page de l'appli. */}
                {isCarteShortPath() && <Route path="/:slug" element={<Suspense fallback={null}><CartePublicPage /></Suspense>} />}
                <Route path="/*" element={
                    <Layout>
                        <Suspense fallback={<div className="flex justify-center items-center py-20"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600"></div></div>}>
                        <Routes>
                            <Route path="/demandes-recurrentes" element={<DemandesRecurrentesPage />} />
                            <Route path="/crm/contacts/:id/demarches" element={<CRMContactDemarchesPage />} />
                            <Route path="/crm/contacts/:id/factures" element={<CRMContactFacturesPage />} />
                            <Route path="/crm/contacts/:id/commandes" element={<CRMContactCommandesPage />} />
                            <Route path="/crm/contacts/:id/rendez-vous" element={<CRMContactHistoriquePage />} />
                            <Route path="/crm/contacts/:id/evenements" element={<CRMContactHistoriquePage />} />
                            <Route path="/mon-tableau-de-bord" element={<PrestationEmployeeDashboard />} />
                            <Route path="/planning" element={<PlanningModule />} />
                            <Route path="/feuille-de-route" element={<RoadmapPage />} />
                            <Route path="/absences" element={<EmployeeAbsences />} />
                            <Route path="/mes-sondages" element={<EmployeeSurveys />} />
                            <Route path="/mon-integration" element={<EmployeeOnboarding />} />
                            <Route path="/mes-notes-de-frais" element={<EmployeeExpenses />} />
                            <Route path="/pointage" element={<EmployeeTimeClock />} />
                            <Route path="/mes-messages" element={<EmployeeMessages />} />
                            <Route path="/crm" element={<CRMModule />} />
                            <Route path="/todo" element={<TodoModule />} />
                            <Route path="/notes" element={<NotesModule />} />
                            <Route path="/crm/contacts/:id" element={<CRMModule />} />
                            <Route path="/fournisseurs" element={<FournisseursModule />} />
                            <Route path="/mon-catalogue" element={<CatalogueFournisseurPage />} />
                            <Route path="/ma-livraison" element={<LivraisonPage />} />
                            <Route path="/mes-clients" element={<MesClientsPage />} />
                            <Route path="/commandes-recues" element={<CommandesRecuesPage />} />
                            <Route path="/demandes" element={<DemandesPage />} />
                            <Route path="/mon-profil-public" element={<ProfilPublicPage />} />
                            <Route path="/fournisseurs/annuaire" element={<AnnuairePage />} />
                            <Route path="/fournisseurs/annuaire/demandes" element={<MesDemandesPage />} />
                            <Route path="/fournisseurs/annuaire/:id" element={<ProfilFournisseurPage />} />
                            <Route path="/fournisseurs/:id" element={<SupplierDetailPage />} />
                            <Route path="/fournisseurs/:id/commandes" element={<SupplierOrdersPage />} />
                            <Route path="/fournisseurs/:id/articles" element={<SupplierArticlesPage />} />
                            <Route path="/fournisseurs/:id/articles/:categoryId" element={<SupplierCategoryArticlesPage />} />
                            <Route path="/extras-partenaires" element={<ExtrasPartnersModule />} />
                            <Route path="/extras-partenaires/:id" element={<ExtrasPartnerDetailPage />} />
                            <Route path="/extras-partenaires/:id/types" element={<ExtrasPartnerTypesPage />} />
                            <Route path="/extras-partenaires/:id/types/:categoryId" element={<ExtrasPartnerCategoryTypesPage />} />
                            <Route path="/extras-partenaires/:id/demandes" element={<ExtrasPartnerRequestsPage />} />
                            <Route path="/extras" element={<ExtrasModule />} />
                            <Route path="/commandes" element={<CommandesModule />} />
                            <Route path="/factures" element={<FacturesModule />} />
                            <Route path="/achats" element={<AchatsModule />} />
                            <Route path="/employes" element={<PostesEmployesModule />} />
                            <Route path="/employes/:id" element={<EmployeeProfilePage />} />
                            <Route path="/demandes-conges" element={<RHModule />} />
                            <Route path="/messagerie" element={<TeamMessagingPage />} />
                            <Route path="/notes-de-frais" element={<NotesDeFraisPage />} />
                            <Route path="/pointage-admin" element={<PointageManagement />} />
                            <Route path="/exception-service" element={<ExceptionServiceModule />} />
                            <Route path="/prestations" element={<PrestationsModule />} />
                            <Route path="/abonnements" element={<DossiersHub vue="contrats" />} />
                            <Route path="/marketing" element={<PubNewsletterModule />} />
                            <Route path="/avis" element={<AvisModule />} />
                            <Route path="/ma-carte" element={<MaCarteModule />} />
                            <Route path="/messagerie-clients" element={<MessagerieModule />} />
                            <Route path="/planning-rdv" element={<PrestationPlanningModule />} />
                            <Route path="/parametres" element={<SettingsPage />} />
                            <Route path="/organisation" element={<OrganisationPage />} />
                            <Route path="/organisation/etablissement" element={<EtablissementPage />} />
                            <Route path="/organisation/services/:id" element={<ServicePage />} />
                            <Route path="/mes-modules" element={<MesModulesPage />} />
                            <Route path="/mon-abonnement" element={<MonAbonnementPage />} />
                            <Route path="/droits-usage" element={<Navigate to="/mes-modules" replace />} />
                            <Route path="/admin/clients/:id/organisation" element={<AdminOrganisationPage />} />
                            <Route path="/admin/groupes" element={<GroupesAdminPage />} />
                            <Route path="/admin/demandes-modules" element={<DemandesModulesPage />} />
                            <Route path="/admin/poles-groupe" element={<PolesGroupeAdminPage />} />
                            <Route path="/organisation/poles-groupe" element={<PolesGroupePage />} />
                            <Route path="/admin/integration" element={<IntegrationListePage />} />
                            <Route path="/admin/integration/:id" element={<IntegrationDossierPage />} />
                            <Route path="/equipe/*" element={<EquipeRoutes />} />
                            <Route path="/reservations" element={<ReservationsPage />} />
                            <Route path="/reservations/reglages" element={<ReglagesServicesPage />} />
                            <Route path="/reservations/reglages/services/:id" element={<ServiceEditionPage />} />
                            <Route path="/reservations/plan" element={<PlanDeSalleHote />} />
                            <Route path="/reservations/plan/formats" element={<FormatsTablesPage />} />
                            <Route path="/reservations/plan-v2" element={<Navigate to="/reservations/plan" replace />} />
                            <Route path="/admin/clients/:id/equipe/*" element={<AdminEquipeRoutes />} />
                            <Route path="/demande-acces" element={<DemanderAccesPage />} />
                            <Route path="/admin/sentinel" element={<SentinelJournal />} />
                            <Route path="/admin/conditions" element={<AcceptationsConditions />} />
                            <Route path="/admin/couts-ia" element={<AdminConseillereCouts />} />
                            <Route path="/admin/factures-plateforme" element={<AdminFacturesPlateforme />} />
                            <Route path="/admin/tarifs-modules" element={<AdminTarifsModules />} />
                            <Route path="/admin/formules" element={<AdminFormules />} />
                            <Route path="/admin/signatures" element={<SignaturesElectroniques />} />
                            <Route path="/admin/settings" element={<AdminSettings />} />
                            <Route path="/admin/collaborator-requests" element={<AdminCollaboratorRequests />} />
                            <Route path="/admin/exception-service-automation-requests" element={<AdminExceptionServiceAutomationRequests />} />
                            <Route path="/jeux" element={<JeuxModule />} />
                            <Route path="/admin/clients" element={<AdminClientsView />} />
                            <Route path="/admin/registration-requests" element={<RegistrationRequestsView />} />
                            <Route path="/admin/clients/:id" element={<AdminClientDetailView />} />
                            <Route path="/admin/support" element={<SupportAdminView />} />
                            <Route path="/admin/messages-clients" element={<MessagesClientsView />} />
                            <Route path="/evenementiel" element={<EvenementielModule />} />
                            <Route path="/evenementiel/parametres" element={<EvenementielSettingsPage />} />
                            <Route path="/menu-plats" element={<MenuCatalogPage />} />
                            <Route path="/menu-plats/allergenes" element={<AllergenFamiliesPage />} />
                            <Route path="/suivi-privatisation" element={<SuiviPrivatisationModule />} />
                            <Route path="/suivi-privatisation/:dossierId" element={<SuiviPrivatisationLayout />}>
                                <Route index element={<Navigate to="pipeline" replace />} />
                                <Route path="pipeline" element={<DossierPipelinePage />} />
                            </Route>
                            <Route path="/suivi-prestation" element={<DossiersHub vue="dossiers" />} />
                            <Route path="/suivi-prestation/:dossierId/pipeline" element={<DossierPrestationPipelinePage />} />
                            <Route path="/devis-prestation" element={<DossiersHub vue="devis" />} />
                            <Route path="/estimation-devis" element={<DossiersHub vue="estimation" />} />
                            <Route path="/commissions" element={<CommissionsPage />} />
                            <Route path="/commerciaux" element={<CommerciauxPage />} />
                            <Route path="/commerciaux/equipe" element={<EquipeCommercialePage />} />
                            <Route path="/commerciaux/challenges" element={<ChallengesCommerciauxPage />} />
                            <Route path="/prospects" element={<PageProspects />} />
                            <Route path="/horaires-equipe" element={<HorairesEquipePage />} />
                            <Route path="/menus-convives" element={<MenusConvivesListPage />} />
                            <Route path="/menus-convives/:eventId" element={<ConvivesSuiviPage />} />
                            <Route path="/menus-convives/:eventId/menu" element={<EvenementielConvivesPage />} />
                            <Route path="/mode-terrain" element={<ModeTerrainListPage />} />
                            <Route path="/mode-terrain/:eventId" element={<ModeTerrainPage />} />
                            <Route path="/menus-convives/:eventId/qr-codes" element={<QrCodesPage />} />
                            <Route path="/origine-viandes" element={<OrigineViandesPage />} />
                            <Route path="/rdv-pro" element={<RdvProModule />} />
                            <Route path="/rdv-pro/annulations" element={<RdvCancellationHistoryPage />} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                        </Suspense>
                    </Layout>
                } />
            </Routes>
        </OrganisationProvider>
        </ConfirmProvider>
        </UndoProvider>
        </AmbianceProvider>
        </AuthProvider>
    </Router>
);

export default App;
